<div class="content" *ngIf="user$ | async as user; else loading">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Owner Dashboard</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a routerLink="dashboard"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item">Dashboard</li>
          <li class="breadcrumb-item active" aria-current="page">Owner Dashboard</li>
        </ol>
      </nav>
    </div>
    <!--<div *ngIf="(subscription$ | async)?.subscriptionStatus !== 'active'" style="cursor: pointer">
      <div
        (click)="redirectToBilling()"
        class="alert alert-solid-primary alert-dismissible fade show"
      >
        Activate your subscription!
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="alert"
          aria-label="Close"
          (click)="$event.stopPropagation()"
        >
          <i class="fas fa-xmark"></i>
        </button>
      </div>
    </div>-->
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
      <div class="me-2 mb-2">
        <div class="dropdown">
          <a
            href="javascript:void(0);"
            class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
            data-bs-toggle="dropdown"
          >
            <i class="ti ti-file-export me-1"></i>Export
          </a>
          <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1"
                ><i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a
              >
            </li>
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1"
                ><i class="ti ti-file-type-xls me-1"></i>Export as Excel
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="input-icon w-120 position-relative mb-2">
        <span class="input-icon-addon">
          <i class="ti ti-calendar text-gray-9"></i>
        </span>
        <input type="text" class="form-control datetimepicker" value="15 Apr 2025" />
      </div>
      <div class="ms-2 head-icons">
        <a
          href="javascript:void(0);"
          class=""
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-original-title="Collapse"
          id="collapse-header"
        >
          <i class="ti ti-chevrons-up"></i>
        </a>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <!-- Employee Dashboard -->
  <!-- <div class="alert bg-secondary-transparent alert-dismissible fade show mb-4">
    Your Leave Request on“24th April 2024”has been Approved!!! <span class="text-danger">*</span>
    <button type="button" class="btn-close fs-14" data-bs-dismiss="alert" aria-label="Close">
      <i class="ti ti-x"></i>
    </button>
  </div> -->
  <div class="row">
    <div class="col-xl-4 d-flex">
      <div class="card position-relative flex-fill">
        <div class="card-header bg-dark">
          <div class="d-flex align-items-center">
            <!-- <span
              class="avatar avatar-lg avatar-rounded border border-white border-2 flex-shrink-0 me-2"
            >
              <img [src]="getEmployeeImage(user)" alt="Img" class="img-fluid rounded-circle" />
            </span> -->
            <span
              class="avatar avatar-sm online rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white"
              style="width: 40px; height: 40px"
            >
              <!-- <ng-container *ngIf="getEmployeeImage(user); else initials">
                <img
                  [src]="getEmployeeImage(user)"
                  alt="Img"
                  class="img-fluid rounded-circle w-100 h-100 object-fit-cover"
                />
              </ng-container>
              <ng-template #initials>
                {{ getInitials(user?.firstName, user?.lastName) }}
              </ng-template> -->
              <ng-container *ngIf="user.picture; else initials">
                <img
                  [src]="apiEndpoint + '/uploads/' + user.picture"
                  class="rounded-circle border border-2"
                  alt="img"
                />
              </ng-container>

              <ng-template #initials>
                <!-- <span
                  class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                  style="width: 40px; height: 40px"
                  >{{ getInitials(user.firstName, user.lastName) }}</span
                > -->
                <span
                  class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                  style="width: 40px; height: 40px"
                  >{{ getInitials(user.firstName, user.lastName) }}</span
                >
              </ng-template>
            </span>
            <div>
              <h5 class="text-white mb-1">{{ user.firstName }} {{ user.lastName }}</h5>
              <div class="d-flex align-items-center">
                <p class="text-white fs-12 mb-0">
                  {{ user.designation ? user.designation.designationName : '' }}
                </p>
                <span class="mx-1">
                  <!-- <i class="ti ti-point-filled text-primary"></i> -->
                </span>
                <p class="fs-12">
                  {{
                    user.designation
                      ? user.designation.department
                        ? user.designation.department.departmentName
                        : ''
                      : ''
                  }}
                </p>
              </div>
            </div>
          </div>
          <!-- <a href="javscript:void(0)" class="btn btn-icon btn-sm text-white rounded-circle edit-top"><i class="ti ti-edit"></i></a> -->
        </div>
        <div class="card-body">
          <div class="mb-3">
            <span class="d-block mb-1 fs-13">Mobile Number</span>
            <p class="text-gray-9">{{ user.mobile }}</p>
          </div>
          <div class="mb-3">
            <span class="d-block mb-1 fs-13">Email Address</span>
            <p class="text-gray-9">
              <a
                href="mailto:{{ user.email }}"
                class="__cf_email__"
                data-cfemail="cd9eb9a8bda8bfa9a8fcfff98da8b5aca0bda1a8e3aea2a0"
                >{{ user.email }}</a
              >
            </p>
          </div>
          <div class="mb-3">
            <span class="d-block mb-1 fs-13">Report Office</span>
            <p class="text-gray-9">{{ user.office ? user.office.officeName : '' }}</p>
          </div>
          <div>
            <span class="d-block mb-1 fs-13">Joined on</span>
            <p class="text-gray-9">
              {{ user.joiningDate ? (user.joiningDate | date: 'mediumDate') : '' }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="clockInOutCount$ | async as count">
      <!-- Attendance Details (Comment) -->
      <!-- <div class="col-xl-5 d-flex">
        <div class="card flex-fill">
          <div class="card-header">
            <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
              <h5>Attendance Details</h5>
            </div>
          </div>
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-md-6">
                <div class="mb-3">
                  <div class="mb-3">
                    <p class="d-flex align-items-center">
                      <i class="ti ti-circle-filled fs-8 text-success me-1"></i>
                      <span class="text-gray-9 fw-semibold me-1">{{
                        count.attendanceDetails.onTime
                      }}</span>
                      on time
                    </p>
                  </div>
                  <div class="mb-3">
                    <p class="d-flex align-items-center">
                      <i class="ti ti-circle-filled fs-8 text-dark me-1"></i>
                      <span class="text-gray-9 fw-semibold me-1">{{
                        count.attendanceDetails.lateAttendance
                      }}</span>
                      Late Attendance
                    </p>
                  </div>
                  <div class="mb-3">
                    <p class="d-flex align-items-center">
                      <i class="ti ti-circle-filled fs-8 text-primary me-1"></i>
                      <span class="text-gray-9 fw-semibold me-1">{{
                        count.attendanceDetails.workFromHome
                      }}</span>
                      Work From Home <span class="text-danger">*</span>
                    </p>
                  </div>
                  <div class="mb-3">
                    <p class="d-flex align-items-center">
                      <i class="ti ti-circle-filled fs-8 text-danger me-1"></i>
                      <span class="text-gray-9 fw-semibold me-1">{{
                        count.attendanceDetails.absent
                      }}</span>
                      Absent
                    </p>
                  </div>
                  <div>
                    <p class="d-flex align-items-center">
                      <i class="ti ti-circle-filled fs-8 text-warning me-1"></i>
                      <span class="text-gray-9 fw-semibold me-1">{{
                        count.attendanceDetails.sickLeave
                      }}</span>
                      Sick Leave
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3 d-flex justify-content-md-end">
                  <apx-chart
                    *ngIf="attendanceChartOptions"
                    [series]="attendanceChartOptions.series"
                    [chart]="attendanceChartOptions.chart"
                    [labels]="attendanceChartOptions.labels"
                    [legend]="attendanceChartOptions.legend"
                    [dataLabels]="attendanceChartOptions.dataLabels"
                    [colors]="attendanceChartOptions.colors"
                    [stroke]="attendanceChartOptions.stroke"
                    [responsive]="attendanceChartOptions.responsive"
                    [tooltip]="attendanceChartOptions.tooltip"
                    [plotOptions]="attendanceChartOptions.plotOptions!"
                  >
                  </apx-chart>
                </div>
              </div>
              <div class="col-md-12" *ngIf="!isBusinessOwner">
                <div class="form-check mt-2">
                  <input class="form-check-input" type="checkbox" id="todo1" />
                  <label class="form-check-label" for="todo1"
                    >Better than
                    <span class="text-gray-9">{{ count.attendanceDetails.performance }}%</span> of
                    Employees</label
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="col-xl-3 d-flex">
        <!-- Leave Details -->
        <div class="card flex-fill">
          <div class="card-header">
            <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
              <h5>Leave Details</h5>
            </div>
          </div>
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-sm-6">
                <div class="mb-4">
                  <span class="d-block mb-1">Total Leaves</span>
                  <h4>{{ count.leaveDetails.totalLeaves }}</h4>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="mb-4">
                  <span class="d-block mb-1">Taken</span>
                  <h4>{{ count.leaveDetails.taken }}</h4>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="mb-4">
                  <span class="d-block mb-1">Absent</span>
                  <h4>{{ count.leaveDetails.absent }}</h4>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="mb-4">
                  <span class="d-block mb-1">Request</span>
                  <h4>{{ count.leaveDetails.request }}</h4>
                </div>
              </div>
              <!-- <div class="col-sm-6">
                <div class="mb-4">
                  <span class="d-block mb-1">Worked Days</span>
                  <h4>{{ count.leaveDetails.workedDays }}</h4>
                </div>
              </div> -->
              <div class="col-sm-6">
                <div class="mb-4">
                  <span class="d-block mb-1">Loss of Pay</span>
                  <h4>{{ count.leaveDetails.lossOfPay }}</h4>
                </div>
              </div>
              <div class="col-sm-12">
                <div>
                  <a
                    href="javscript:void(0)"
                    [routerLink]="eps.leaves.leavesRequestPath"
                    class="btn btn-dark w-100"
                    data-bs-toggle="modal"
                    data-bs-target="#add_leaves"
                    >Apply New Leave</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <!-- Attendance ClockIn Punch (Comment) -->
  <!-- <div class="row">
    <div class="col-xl-4 d-flex">
      <div class="card flex-fill border-primary attendance-bg">
        <div class="card-body">
          <div class="mb-4 text-center">
            <h6 class="fw-medium text-gray-5 mb-1">Attendance</h6>
            <h4>{{ currentDate | date: 'medium' }}</h4>
          </div>
          <div class="attendance-circle-progress attendance-progress mx-auto mb-3" data-value="65">
            <span class="progress-left">
              <span class="progress-bar border-success"></span>
            </span>
            <span class="progress-right">
              <span class="progress-bar border-success"> </span>
            </span>
            <div class="total-work-hours text-center w-100">
              <span class="fs-13 d-block mb-1">Total Hours</span>
              <h6>{{ totalWorkHoursIncludingCurrent$ | async }}</h6>
            </div>
          </div>
          <div class="text-center">
            <ng-container *ngIf="isPunchedIn$ | async as isPunchedIn; else punchedIn">
              <ng-container *ngIf="isPunchedIn; else punchedIn">
                <ng-container *ngIf="latestPunchIn$ | async as latestPunchIn">
                  <span>
                    <h6 class="fw-medium d-flex align-items-center justify-content-center mb-4">
                      <i class="ti ti-fingerprint text-primary me-1"></i>
                      Clock In at {{ latestPunchIn.clockIn | date: 'EEE, MMM dd, yyyy, hh:mm a' }}
                    </h6>
                  </span>
                </ng-container>
                <button
                  type="button"
                  class="btn btn-primary punch-btn w-100"
                  (click)="punchOut()"
                  [disabled]="isLoading$ | async"
                >
                  <ng-container *ngIf="isLoading$ | async; else loading">
                    <span
                      class="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Clock Out...
                  </ng-container>
                  <ng-template #loading> Clock Out </ng-template>
                </button>
              </ng-container>
            </ng-container>

            <ng-template #punchedIn>
              Show Punch Out button if punched in
              <span *ngIf="latestPunchIn$ | async as latestPunchIn">
                <span *ngIf="latestPunchIn?.workStatus === workstatusEnum.CLOCKIN">
                  <h6 class="fw-medium d-flex align-items-center justify-content-center mb-4">
                    <i class="ti ti-fingerprint text-primary me-1"></i>
                    Last Clock Out at
                    {{ latestPunchIn.clockOut | date: 'EEE, MMM dd, yyyy, hh:mm a' }}
                  </h6>
                </span>
              </span>
              <button
                type="button"
                class="btn btn-primary punch-btn w-100"
                (click)="punchIn()"
                [disabled]="isLoading$ | async"
              >
                <ng-container *ngIf="isLoading$ | async; else loading">
                  <span
                    class="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Clocking...
                </ng-container>
                <ng-template #loading> Clock In </ng-template>
              </button>
            </ng-template>
          </div>
        </div>
      </div>
    </div> -->

  <!-- Attendance Hours Live Progress-->
  <!--<div class="col-xl-8 d-flex">
      <div class="row flex-fill">
        <div class="col-xl-3 col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="pb-2">
                <span class="avatar avatar-sm bg-primary mb-2"
                  ><i class="ti ti-clock-stop"></i
                ></span>
                <h2 class="mb-2">
                  {{ totalWithBreakToday$ | async }} /
                  <span class="fs-20 text-gray-5"> {{ expectedWorkHoursToday$ | async }}</span>
                </h2>
                <p class="fw-medium text-truncate">Total Hours Today</p>
              </div>
              <div class="d-none">
                <p class="d-flex align-items-center fs-13">
                  <span class="avatar avatar-xs rounded-circle bg-success flex-shrink-0 me-2">
                    <i class="ti ti-arrow-up fs-12"></i>
                  </span>
                  <span>5% This Week</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="pb-2">
                <span class="avatar avatar-sm bg-dark mb-2"><i class="ti ti-clock-up"></i></span>
                <h2 class="mb-2">
                  {{ liveWeek$ | async }} /
                  <span class="fs-20 text-gray-5">{{ expectedWorkHoursThisWeek$ | async }}</span>
                </h2>
                <p class="fw-medium text-truncate">Total Hours Week</p>
              </div>
              <div class="d-none">
                <p class="d-flex align-items-center fs-13">
                  <span class="avatar avatar-xs rounded-circle bg-success flex-shrink-0 me-2">
                    <i class="ti ti-arrow-up fs-12"></i>
                  </span>
                  <span>7% Last Week</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="pb-2">
                <span class="avatar avatar-sm bg-info mb-2"><i class="ti ti-calendar-up"></i></span>
                 <h2 class="mb-2">
                  {{ liveMonth$ | async }} /
                  <span class="fs-20 text-gray-5"> {{ expectedWorkHoursThisMonth$ | async }} </span>
                </h2>
                <p class="fw-medium text-truncate">Total Hours Month</p>
              </div>
              <div class="d-none">
                <p class="d-flex align-items-center fs-13 text-truncate">
                  <span class="avatar avatar-xs rounded-circle bg-danger flex-shrink-0 me-2">
                    <i class="ti ti-arrow-down fs-12"></i>
                  </span>
                  <span>8% Last Month</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="pb-2">
                <span class="avatar avatar-sm bg-pink mb-2"
                  ><i class="ti ti-calendar-star"></i
                ></span>
                <h2 class="mb-2">16 / <span class="fs-20 text-gray-5"> 28</span></h2>
                <p class="fw-medium text-truncate">
                  Overtime this Month <span class="text-danger">*</span>
                </p>
              </div>
              <div class="d-none">
                <p class="d-flex align-items-center fs-13 text-truncate">
                  <span class="avatar avatar-xs rounded-circle bg-danger flex-shrink-0 me-2">
                    <i class="ti ti-arrow-down fs-12"></i>
                  </span>
                  <span>6% Last Month</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-xl-3">
                  <div class="mb-4">
                    <p class="d-flex align-items-center mb-1">
                      <i class="ti ti-point-filled text-dark-transparent me-1"></i>Total Working
                      Hours
                    </p>
                    <h3>{{ totalWithBreakToday$ | async }}</h3>
                  </div>
                </div>
                <div class="col-xl-3">
                  <div class="mb-4">
                    <p class="d-flex align-items-center mb-1">
                      <i class="ti ti-point-filled text-success me-1"></i>Productive Hours
                    </p>
                    <h3>{{ liveToday$ | async }}</h3>
                  </div>
                </div>
                <div class="col-xl-3">
                  <div class="mb-4">
                    <p class="d-flex align-items-center mb-1">
                      <i class="ti ti-point-filled text-warning me-1"></i>Break Hours
                    </p>
                    <h3>{{ totalBreakHoursToday$ | async }}</h3>
                  </div>
                </div>
                <div class="col-xl-3">
                  <div class="mb-4">
                    <p class="d-flex align-items-center mb-1">
                      <i class="ti ti-point-filled text-info me-1"></i>Overtime
                      <span class="text-danger">*</span>
                    </p>
                    <h3>02h 15m</h3>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="progress bg-transparent-dark mb-3" style="height: 24px">
                    <ng-container *ngFor="let progress of progressData">
                      <div
                        class="progress-bar rounded"
                        [ngClass]="progress.color"
                        role="progressbar"
                        [style.width]="progress.width"
                      ></div>
                    </ng-container>
                  </div>
                </div>
                <div class="col-md-12">
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-2"
                  >
                    <ng-container *ngFor="let hour of timeLabels">
                      <span class="fs-10">{{ hour }}</span>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <!-- Project Comment -->
  <!-- <div class="row">
    <div class="col-xl-6 d-flex">
      <div class="card flex-fill">
        <div class="card-header">
          <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
            <h5>Projects <span class="text-danger">*</span></h5>
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="btn btn-white border-0 dropdown-toggle border btn-sm d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Ongoing Projects
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">All Projects</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">Ongoing Projects</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <div class="card mb-4 shadow-none mb-md-0">
                <div class="card-body">
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <h6>Office Management</h6>
                    <div class="dropdown">
                      <a
                        href="javascript:void(0);"
                        class="d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        <i class="ti ti-dots-vertical"></i>
                      </a>
                      <ul class="dropdown-menu dropdown-menu-end p-3">
                        <li>
                          <a
                            href="javascript:void(0);"
                            class="dropdown-item rounded-1"
                            data-bs-toggle="modal"
                            data-bs-target="#edit_task"
                            ><i class="ti ti-edit me-2"></i>Edit</a
                          >
                        </li>
                        <li>
                          <a
                            href="javascript:void(0);"
                            class="dropdown-item rounded-1"
                            data-bs-toggle="modal"
                            data-bs-target="#delete_modal"
                            ><i class="ti ti-trash me-2"></i>Delete</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div>
                    <div class="d-flex align-items-center mb-3">
                      <a href="javascript:void(0);" class="avatar">
                        <img
                          src="../../../../assets/img/users/user-32.jpg"
                          class="img-fluid rounded-circle"
                          alt="img"
                        />
                      </a>
                      <div class="ms-2">
                        <h6 class="fw-normal"><a href="javascript:void(0);">Anthony Lewis</a></h6>
                        <span class="fs-13 d-block">Project Leader</span>
                      </div>
                    </div>
                    <div class="d-flex align-items-center mb-3">
                      <a href="javascript:void(0);" class="avatar bg-soft-primary rounded-circle">
                        <i class="ti ti-calendar text-primary fs-16"></i>
                      </a>
                      <div class="ms-2">
                        <h6 class="fw-normal">14 Jan 2024</h6>
                        <span class="fs-13 d-block">Deadline</span>
                      </div>
                    </div>
                    <div
                      class="d-flex align-items-center justify-content-between bg-transparent-light border border-dashed rounded p-2 mb-3"
                    >
                      <div class="d-flex align-items-center">
                        <span class="avatar avatar-sm bg-success-transparent rounded-circle me-1"
                          ><i class="ti ti-checklist fs-16"></i
                        ></span>
                        <p>Tasks : <span class="text-gray-9">6 </span> /10</p>
                      </div>
                      <div class="avatar-list-stacked avatar-group-sm">
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="../../../../assets/img/profiles/avatar-06.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="../../../../assets/img/profiles/avatar-07.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="../../../../assets/img/profiles/avatar-08.jpg"
                            alt="img"
                          />
                        </span>
                        <a
                          class="avatar bg-primary avatar-rounded text-fixed-white fs-12 fw-medium"
                          href="javascript:void(0);"
                        >
                          +2
                        </a>
                      </div>
                    </div>
                    <div
                      class="bg-soft-secondary p-2 rounded d-flex align-items-center justify-content-between"
                    >
                      <p class="text-secondary mb-0 text-truncate">Time Spent</p>
                      <h5 class="text-secondary text-truncate">
                        65/120 <span class="fs-14 fw-normal">Hrs</span>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card shadow-none mb-0">
                <div class="card-body">
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <h6>Office Management</h6>
                    <div class="dropdown">
                      <a
                        href="javascript:void(0);"
                        class="d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        <i class="ti ti-dots-vertical"></i>
                      </a>
                      <ul class="dropdown-menu dropdown-menu-end p-3">
                        <li>
                          <a
                            href="javascript:void(0);"
                            class="dropdown-item rounded-1"
                            data-bs-toggle="modal"
                            data-bs-target="#edit_task"
                            ><i class="ti ti-edit me-2"></i>Edit</a
                          >
                        </li>
                        <li>
                          <a
                            href="javascript:void(0);"
                            class="dropdown-item rounded-1"
                            data-bs-toggle="modal"
                            data-bs-target="#delete_modal"
                            ><i class="ti ti-trash me-2"></i>Delete</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div>
                    <div class="d-flex align-items-center mb-3">
                      <a href="javascript:void(0);" class="avatar">
                        <img
                          src="../../../../assets/img/users/user-33.jpg"
                          class="img-fluid rounded-circle"
                          alt="img"
                        />
                      </a>
                      <div class="ms-2">
                        <h6 class="fw-normal"><a href="javascript:void(0);">Anthony Lewis</a></h6>
                        <span class="fs-13 d-block">Project Leader</span>
                      </div>
                    </div>
                    <div class="d-flex align-items-center mb-3">
                      <a href="javascript:void(0);" class="avatar bg-soft-primary rounded-circle">
                        <i class="ti ti-calendar text-primary fs-16"></i>
                      </a>
                      <div class="ms-2">
                        <h6 class="fw-normal">14 Jan 2024</h6>
                        <span class="fs-13 d-block">Deadline</span>
                      </div>
                    </div>
                    <div
                      class="d-flex align-items-center justify-content-between bg-transparent-light border border-dashed rounded p-2 mb-3"
                    >
                      <div class="d-flex align-items-center">
                        <span class="avatar avatar-sm bg-success-transparent rounded-circle me-1"
                          ><i class="ti ti-checklist fs-16"></i
                        ></span>
                        <p>Tasks : <span class="text-gray-9">6 </span> /10</p>
                      </div>
                      <div class="avatar-list-stacked avatar-group-sm">
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="../../../../assets/img/profiles/avatar-06.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="../../../../assets/img/profiles/avatar-07.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="../../../../assets/img/profiles/avatar-08.jpg"
                            alt="img"
                          />
                        </span>
                        <a
                          class="avatar bg-primary avatar-rounded text-fixed-white fs-12 fw-medium"
                          href="javascript:void(0);"
                        >
                          +2
                        </a>
                      </div>
                    </div>
                    <div
                      class="bg-soft-secondary p-2 rounded d-flex align-items-center justify-content-between"
                    >
                      <p class="text-secondary mb-0 text-truncate">Time Spent</p>
                      <h5 class="text-secondary text-truncate">
                        65/120 <span class="fs-14 fw-normal">Hrs</span>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-6 d-flex">
      <div class="card flex-fill">
        <div class="card-header">
          <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
            <h5>Tasks <span class="text-danger">*</span></h5>
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="btn btn-white border-0 dropdown-toggle border btn-sm d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                All Projects
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">All Projects</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">Ongoing Projects</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="list-group list-group-flush">
            <div class="list-group-item border rounded mb-3 p-2">
              <div class="row align-items-center row-gap-3">
                <div class="col-md-8">
                  <div class="todo-inbox-check d-flex align-items-center">
                    <span><i class="ti ti-grid-dots me-2"></i></span>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" />
                    </div>
                    <span class="me-2 d-flex align-items-center rating-select"
                      ><i class="ti ti-star-filled filled"></i
                    ></span>
                    <div class="strike-info">
                      <h4 class="fs-14 text-truncate">Patient appointment booking</h4>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="d-flex align-items-center justify-content-md-end flex-wrap row-gap-3">
                    <span class="badge bg-soft-pink d-inline-flex align-items-center me-2"
                      ><i class="fas fa-circle fs-6 me-1"></i>Onhold</span
                    >
                    <div class="d-flex align-items-center">
                      <div class="avatar-list-stacked avatar-group-sm">
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="../../../../assets/img/profiles/avatar-13.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="../../../../assets/img/profiles/avatar-14.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="../../../../assets/img/profiles/avatar-15.jpg"
                            alt="img"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="list-group-item border rounded mb-3 p-2">
              <div class="row align-items-center row-gap-3">
                <div class="col-md-8">
                  <div class="todo-inbox-check d-flex align-items-center">
                    <span><i class="ti ti-grid-dots me-2"></i></span>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" />
                    </div>
                    <span class="me-2 rating-select d-flex align-items-center"
                      ><i class="ti ti-star"></i
                    ></span>
                    <div class="strike-info">
                      <h4 class="fs-14 text-truncate">Appointment booking with payment</h4>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="d-flex align-items-center justify-content-md-end flex-wrap row-gap-3">
                    <span class="badge bg-transparent-purple d-flex align-items-center me-2"
                      ><i class="fas fa-circle fs-6 me-1"></i>Inprogress</span
                    >
                    <div class="d-flex align-items-center">
                      <div class="avatar-list-stacked avatar-group-sm">
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="../../../../assets/img/profiles/avatar-20.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="../../../../assets/img/profiles/avatar-21.jpg"
                            alt="img"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="list-group-item border rounded mb-3 p-2">
              <div class="row align-items-center row-gap-3">
                <div class="col-md-8">
                  <div class="todo-inbox-check d-flex align-items-center">
                    <span><i class="ti ti-grid-dots me-2"></i></span>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" />
                    </div>
                    <span class="me-2 rating-select d-flex align-items-center"
                      ><i class="ti ti-star"></i
                    ></span>
                    <div class="strike-info">
                      <h4 class="fs-14 text-truncate">Patient and Doctor video conferencing</h4>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="d-flex align-items-center justify-content-md-end flex-wrap row-gap-3">
                    <span class="badge badge-soft-success align-items-center me-2"
                      ><i class="fas fa-circle fs-6 me-1"></i>Completed</span
                    >
                    <div class="d-flex align-items-center">
                      <div class="avatar-list-stacked avatar-group-sm">
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="../../../../assets/img/profiles/avatar-28.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="../../../../assets/img/profiles/avatar-29.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="../../../../assets/img/profiles/avatar-24.jpg"
                            alt="img"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="list-group-item border rounded mb-3 p-2">
              <div class="row align-items-center row-gap-3">
                <div class="col-md-8">
                  <div class="todo-inbox-check d-flex align-items-center todo-strike-content">
                    <span><i class="ti ti-grid-dots me-2"></i></span>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" checked="" />
                    </div>
                    <span class="me-2 rating-select d-flex align-items-center"
                      ><i class="ti ti-star"></i
                    ></span>
                    <div class="strike-info">
                      <h4 class="fs-14 text-truncate">Private chat module</h4>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="d-flex align-items-center justify-content-md-end flex-wrap row-gap-3">
                    <span class="badge badge-secondary-transparent d-flex align-items-center me-2"
                      ><i class="fas fa-circle fs-6 me-1"></i>Pending</span
                    >
                    <div class="d-flex align-items-center">
                      <div class="avatar-list-stacked avatar-group-sm">
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="../../../../assets/img/profiles/avatar-23.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="../../../../assets/img/profiles/avatar-24.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="../../../../assets/img/profiles/avatar-25.jpg"
                            alt="img"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="list-group-item border rounded p-2">
              <div class="row align-items-center row-gap-3">
                <div class="col-md-8">
                  <div class="todo-inbox-check d-flex align-items-center">
                    <span><i class="ti ti-grid-dots me-2"></i></span>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" />
                    </div>
                    <span class="me-2 rating-select d-flex align-items-center"
                      ><i class="ti ti-star"></i
                    ></span>
                    <div class="strike-info">
                      <h4 class="fs-14 text-truncate">Go-Live and Post-Implementation Support</h4>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="d-flex align-items-center justify-content-md-end flex-wrap row-gap-3">
                    <span class="badge bg-transparent-purple d-flex align-items-center me-2"
                      ><i class="fas fa-circle fs-6 me-1"></i>Inprogress</span
                    >
                    <div class="d-flex align-items-center">
                      <div class="avatar-list-stacked avatar-group-sm">
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="../../../../assets/img/profiles/avatar-28.jpg"
                            alt="img"
                          />
                        </span>
                        <span class="avatar avatar-rounded">
                          <img
                            class="border border-white"
                            src="../../../../assets/img/profiles/avatar-29.jpg"
                            alt="img"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <!-- Performance Comment -->
  <!-- <div class="row">
    <div class="col-xl-5 d-flex">
      <div class="card flex-fill">
        <div class="card-header">
          <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
            <h5>Performance <span class="text-danger">*</span></h5>
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="btn btn-white border btn-sm d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-calendar me-1"></i>2024
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">2024</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">2023</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">2022</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div>
            <div class="bg-light d-flex align-items-center rounded p-2">
              <h3 class="me-2">98%</h3>
              <span class="badge badge-outline-success bg-success-transparent rounded-pill me-1"
                >12%</span
              >
              <span>vs last years</span>
            </div>
            <div id="performance_chart2"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-4 d-flex">
      <div class="card flex-fill">
        <div class="card-header">
          <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
            <h5>My Skills <span class="text-danger">*</span></h5>
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="btn btn-white border btn-sm d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-calendar me-1"></i>2024
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">2024</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">2023</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">2022</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div>
            <div class="border border-dashed bg-transparent-light rounded p-2 mb-2">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <span class="d-block border border-2 h-12 border-primary rounded-5 me-2"></span>
                  <div>
                    <h6 class="fw-medium mb-1">Figma</h6>
                    <p>Updated : 15 May 2025</p>
                  </div>
                </div>
                <div class="circle-progress circle-progress-md" data-value="95">
                  <span class="progress-left">
                    <span class="progress-bar border-primary"></span>
                  </span>
                  <span class="progress-right">
                    <span class="progress-bar border-primary"></span>
                  </span>
                  <div class="progress-value">95%</div>
                </div>
              </div>
            </div>
            <div class="border border-dashed bg-transparent-light rounded p-2 mb-2">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <span class="d-block border border-2 h-12 border-success rounded-5 me-2"></span>
                  <div>
                    <h6 class="fw-medium mb-1">HTML</h6>
                    <p>Updated : 12 May 2025</p>
                  </div>
                </div>
                <div class="circle-progress circle-progress-md" data-value="85">
                  <span class="progress-left">
                    <span class="progress-bar border-success"></span>
                  </span>
                  <span class="progress-right">
                    <span class="progress-bar border-success"></span>
                  </span>
                  <div class="progress-value">85%</div>
                </div>
              </div>
            </div>
            <div class="border border-dashed bg-transparent-light rounded p-2 mb-2">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <span class="d-block border border-2 h-12 border-purple rounded-5 me-2"></span>
                  <div>
                    <h6 class="fw-medium mb-1">CSS</h6>
                    <p>Updated : 12 May 2025</p>
                  </div>
                </div>
                <div class="circle-progress circle-progress-md" data-value="70">
                  <span class="progress-left">
                    <span class="progress-bar border-purple"></span>
                  </span>
                  <span class="progress-right">
                    <span class="progress-bar border-purple"></span>
                  </span>
                  <div class="progress-value">70%</div>
                </div>
              </div>
            </div>
            <div class="border border-dashed bg-transparent-light rounded p-2 mb-2">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <span class="d-block border border-2 h-12 border-info rounded-5 me-2"></span>
                  <div>
                    <h6 class="fw-medium mb-1">Wordpress</h6>
                    <p>Updated : 15 May 2025</p>
                  </div>
                </div>
                <div class="circle-progress circle-progress-md" data-value="61">
                  <span class="progress-left">
                    <span class="progress-bar border-info"></span>
                  </span>
                  <span class="progress-right">
                    <span class="progress-bar border-info"></span>
                  </span>
                  <div class="progress-value">61%</div>
                </div>
              </div>
            </div>
            <div class="border border-dashed bg-transparent-light rounded p-2">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <span class="d-block border border-2 h-12 border-dark rounded-5 me-2"></span>
                  <div>
                    <h6 class="fw-medium mb-1">Javascript</h6>
                    <p>Updated : 13 May 2025</p>
                  </div>
                </div>
                <div class="circle-progress circle-progress-md" data-value="58">
                  <span class="progress-left">
                    <span class="progress-bar border-dark"></span>
                  </span>
                  <span class="progress-right">
                    <span class="progress-bar border-dark"></span>
                  </span>
                  <div class="progress-value">58%</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

  <!-- Team BrithDay Comment -->
  <!-- <div class="col-xl-3 d-flex">
      <div class="flex-fill">
        <div class="card card-bg-5 bg-dark mb-3">
          <div class="card-body">
            <div class="text-center">
              <h5 class="text-white mb-4">Team Birthday</h5>
              <div id="carouselExampleDark" class="carousel slide" data-bs-ride="carousel">             
                <ng-container
                  *ngIf="birthdayEmployees && birthdayEmployees.length > 0; else noBirthdayRecord"
                >
                  <div class="carousel-inner">
                    <div
                      class="carousel-item"
                      [ngClass]="{ active: isFirst }"
                      data-bs-interval="10000"
                      *ngFor="let member of birthdayEmployees; let isFirst = first"
                    >
                      <span class="avatar avatar-xl avatar-rounded mb-2">
                        <ng-container *ngIf="member.picture; else initials">
                          <img
                            [src]="apiEndpoint + '/uploads/' + member.picture"
                            class="rounded-circle border border-2"
                            alt="img"
                          />
                        </ng-container>

                        <ng-template #initials>
                          <span
                            class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                            style="width: 40px; height: 40px"
                            >{{ getInitials(member.firstName, member.lastName) }}</span
                          >
                        </ng-template>
                      </span>
                      <div class="mb-3">
                        <h6 class="text-white fw-medium mb-1">
                          {{ member.firstName }} {{ member.lastName }}
                        </h6>
                        <p>{{ member.designation?.designationName }}</p>
                        <p class="text-fixed-white">{{ member.birthdate | date: 'MMM d' }}</p>
                      </div>
                      <a href="javascript:void(0)" class="btn btn-sm btn-primary">Send Wishes</a>
                    </div>                    
                  </div>
                  <button
                    class="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselExampleDark"
                    data-bs-slide="prev"
                  >
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                  </button>
                  <button
                    class="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselExampleDark"
                    data-bs-slide="next"
                  >
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                  </button>
                </ng-container>

                <ng-template #noBirthdayRecord> No birthday record in next 3 months. </ng-template>
              </div>
            </div>
          </div>
        </div> -->

  <!-- Leave Policy -->
  <!-- <div class="card bg-secondary mb-3">
          <div class="card-body d-flex align-items-center justify-content-between p-3">
            <div>
              <h5 class="text-white mb-1">Leave Policy</h5>
            </div>
            <a class="btn btn-white btn-sm px-3" [routerLink]="linkPath" [queryParams]="queryParams"
              >View All</a
            >
          </div>
        </div>
        <div class="card bg-warning">
          <div class="card-body d-flex align-items-center justify-content-between p-3">
            <div>
              <h5 class="mb-1">Next Holiday</h5>
              <p class="text-gray-9">
                {{
                  nextHoliday
                    ? nextHoliday.title + ', ' + (nextHoliday.date | date: 'dd MMM yyyy')
                    : 'No upcoming holidays'
                }}
              </p>
            </div>
            <a
              class="btn btn-white btn-sm px-3"
              [routerLink]="['/', eps.leaves.base, eps.leaves.holidays]"
              >View All</a
            >
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <!-- Team Members Comment -->
  <!-- <div class="row">
    <div class="col-xl-4 d-flex">
      <div class="card flex-fill">
        <div class="card-header">
          <div class="d-flex align-items-center justify-content-between flex-wrap">
            <h5>Team Members</h5>
            <a
              class="btn btn-light btn-sm"
              [routerLink]="[
                '/',
                eps.employeeManager.base,
                eps.employeeManager.teamMembers,
                user?.id
              ]"
            >
              View All
            </a>
          </div>
        </div>
        <div class="card-body">
          <ng-container *ngIf="teamMembers$ | async as teamMembers">
            <div *ngIf="teamMembers.length > 0">
              <div
                class="d-flex align-items-center justify-content-between mb-4"
                *ngFor="let member of teamMembers"
                [hidden]="member.disabled"
              >
                <div class="d-flex align-items-center">
                  <a href="javascript:void(0);" class="avatar flex-shrink-0">
                    <ng-container *ngIf="member.picture; else initials">
                      <img
                        [src]="apiEndpoint + '/uploads/' + member.picture"
                        class="rounded-circle border border-2"
                        alt="img"
                      />
                    </ng-container>

                    <ng-template #initials>
                      <span
                        class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                        style="width: 40px; height: 40px"
                        >{{ getInitials(member.firstName, member.lastName) }}</span
                      >
                    </ng-template>
                  </a>
                  <div class="ms-2">
                    <h6 class="fs-14 fw-medium text-truncate mb-1">
                      <a href="javascript:void(0);">{{ member.firstName }} {{ member.lastName }}</a>
                    </h6>
                    <p class="fs-13">{{ member.designation?.designationName || 'N/A' }}</p>
                  </div>
                </div>                
              </div>
            </div>
          </ng-container>

          
        </div>
      </div>
    </div> -->

  <!-- Notification Comment -->
  <!-- <div class="col-xl-4 d-flex">
      <div class="card flex-fill">
        <div class="card-header">
          <div class="d-flex align-items-center justify-content-between flex-wrap">
            <h5>Notifications</h5>
            <div>
              <a
                class="btn btn-light btn-sm"
                [routerLink]="['/', eps.notifications.notifications, user?.id]"
                >View All</a
              >
            </div>
          </div>
        </div>
        <div class="card-body">
          <ng-container *ngIf="notifications && notifications.length > 0; else noNotifications">
            <div class="d-flex align-items-start mb-4" *ngFor="let notification of notifications">
              <div class="ms-2">
                <h6 class="fs-14 fw-medium text-truncate mb-1">
                  {{ notification.title }}
                </h6>
                <p class="fs-13 mb-2">{{ notification.createdAt | date: 'medium' }}</p>
                </div>
            </div>
          </ng-container>
          <ng-template #noNotifications>
            <p>You're all caught up! No new notifications.</p>
          </ng-template>
          </div>
      </div> -->
  <!-- </div> -->

  <!-- Meeting Schedule Comment -->
  <!-- <div class="col-xl-4 d-flex">
      <div class="card flex-fill">
        <div class="card-header">
          <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
            <h5>Meetings Schedule <span class="text-danger">*</span></h5>
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="btn btn-white border btn-sm d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-calendar me-1"></i>Today
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">Today</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">This Month</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">This Year</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-body schedule-timeline">
          <div class="d-flex align-items-start">
            <div class="d-flex align-items-center active-time">
              <span>09:25 AM</span>
              <span><i class="ti ti-point-filled text-primary fs-20"></i></span>
            </div>
            <div class="flex-fill ps-3 pb-4 timeline-flow">
              <div class="bg-light p-2 rounded">
                <p class="fw-medium text-gray-9 mb-1">Marketing Strategy Presentation</p>
                <span>Marketing</span>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-start">
            <div class="d-flex align-items-center active-time">
              <span>09:20 AM</span>
              <span><i class="ti ti-point-filled text-secondary fs-20"></i></span>
            </div>
            <div class="flex-fill ps-3 pb-4 timeline-flow">
              <div class="bg-light p-2 rounded">
                <p class="fw-medium text-gray-9 mb-1">
                  Design Review Hospital, doctors Management Project
                </p>
                <span>Review</span>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-start">
            <div class="d-flex align-items-center active-time">
              <span>09:18 AM</span>
              <span><i class="ti ti-point-filled text-warning fs-20"></i></span>
            </div>
            <div class="flex-fill ps-3 pb-4 timeline-flow">
              <div class="bg-light p-2 rounded">
                <p class="fw-medium text-gray-9 mb-1">Birthday Celebration of Employee</p>
                <span>Celebration</span>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-start">
            <div class="d-flex align-items-center active-time">
              <span>09:10 AM</span>
              <span><i class="ti ti-point-filled text-success fs-20"></i></span>
            </div>
            <div class="flex-fill ps-3 timeline-flow">
              <div class="bg-light p-2 rounded">
                <p class="fw-medium text-gray-9 mb-1">Update of Project Flow</p>
                <span>Development</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <!-- Admin Dashboard -->
  <!-- Admin Dashboard -->
  <!-- Admin Dashboard -->
  <!-- Admin Dashboard -->
  <!-- Admin Dashboard -->
  <!-- Admin Dashboard -->
  <!-- Admin Dashboard -->
  <!-- Admin Dashboard -->
  <!-- Admin Dashboard -->
  <!-- Admin Dashboard -->
  <!-- Admin Dashboard -->
  <!-- Admin Dashboard -->
  <!-- Admin Dashboard -->
  <!-- Admin Dashboard -->
  <!-- Admin Dashboard -->
  <!-- Admin Dashboard -->
  <!-- Admin Dashboard -->
  <!-- Admin Dashboard -->
  <!-- Admin Dashboard -->

  <!-- Page Wrapper -->
  <!-- <div class="page-wrapper" style="margin-left: 5px !important"> -->
  <!-- <div class="content"> -->
  <!-- Welcome Wrap -->

  <div class="row">
    <!-- Widget Info -->
    <div class="col-xxl-8 d-flex">
      <div class="row flex-fill">
        <div class="col-md-3 d-flex">
          <div class="card flex-fill">
            <div class="card-body">
              <span class="avatar rounded-circle bg-primary mb-2">
                <i class="ti ti-calendar-share fs-16"></i>
              </span>
              <h6 class="fs-13 fw-medium text-default mb-1">Attendance Overview</h6>
              <h3 class="mb-3">
                120/154
                <span class="fs-12 fw-medium text-success"
                  ><i class="fa-solid fa-caret-up me-1"></i>+2.1%</span
                >
              </h3>
              <a href="attendance-employee.html" class="link-default">View Details</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 d-flex">
          <div class="card flex-fill">
            <div class="card-body">
              <span class="avatar rounded-circle bg-secondary mb-2">
                <i class="ti ti-browser fs-16"></i>
              </span>
              <h6 class="fs-13 fw-medium text-default mb-1">Total No of Project's</h6>
              <h3 class="mb-3">
                90/125
                <span class="fs-12 fw-medium text-danger"
                  ><i class="fa-solid fa-caret-down me-1"></i>-2.1%</span
                >
              </h3>
              <a href="projects.html" class="link-default">View All</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 d-flex">
          <div class="card flex-fill">
            <div class="card-body">
              <span class="avatar rounded-circle bg-info mb-2">
                <i class="ti ti-users-group fs-16"></i>
              </span>
              <h6 class="fs-13 fw-medium text-default mb-1">Total No of Clients</h6>
              <h3 class="mb-3">
                69/86
                <span class="fs-12 fw-medium text-danger"
                  ><i class="fa-solid fa-caret-down me-1"></i>-11.2%</span
                >
              </h3>
              <a href="clients.html" class="link-default">View All</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 d-flex">
          <div class="card flex-fill">
            <div class="card-body">
              <span class="avatar rounded-circle bg-pink mb-2">
                <i class="ti ti-checklist fs-16"></i>
              </span>
              <h6 class="fs-13 fw-medium text-default mb-1">Total No of Tasks</h6>
              <h3 class="mb-3">
                225/28
                <span class="fs-12 fw-medium text-success"
                  ><i class="fa-solid fa-caret-down me-1"></i>+11.2%</span
                >
              </h3>
              <a href="tasks.html" class="link-default">View All</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 d-flex">
          <div class="card flex-fill">
            <div class="card-body">
              <span class="avatar rounded-circle bg-purple mb-2">
                <i class="ti ti-moneybag fs-16"></i>
              </span>
              <h6 class="fs-13 fw-medium text-default mb-1">Earnings</h6>
              <h3 class="mb-3">
                $21445
                <span class="fs-12 fw-medium text-success"
                  ><i class="fa-solid fa-caret-up me-1"></i>+10.2%</span
                >
              </h3>
              <a href="expenses.html" class="link-default">View All</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 d-flex">
          <div class="card flex-fill">
            <div class="card-body">
              <span class="avatar rounded-circle bg-danger mb-2">
                <i class="ti ti-browser fs-16"></i>
              </span>
              <h6 class="fs-13 fw-medium text-default mb-1">Profit This Week</h6>
              <h3 class="mb-3">
                $5,544
                <span class="fs-12 fw-medium text-success"
                  ><i class="fa-solid fa-caret-up me-1"></i>+2.1%</span
                >
              </h3>
              <a href="purchase-transaction.html" class="link-default">View All</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 d-flex">
          <div class="card flex-fill">
            <div class="card-body">
              <span class="avatar rounded-circle bg-success mb-2">
                <i class="ti ti-users-group fs-16"></i>
              </span>
              <h6 class="fs-13 fw-medium text-default mb-1">Job Applicants</h6>
              <h3 class="mb-3">
                98
                <span class="fs-12 fw-medium text-success"
                  ><i class="fa-solid fa-caret-up me-1"></i>+2.1%</span
                >
              </h3>
              <a href="job-list.html" class="link-default">View All</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 d-flex">
          <div class="card flex-fill">
            <div class="card-body">
              <span class="avatar rounded-circle bg-dark mb-2">
                <i class="ti ti-user-star fs-16"></i>
              </span>
              <h6 class="fs-13 fw-medium text-default mb-1">New Hire</h6>
              <h3 class="mb-3">
                45/48
                <span class="fs-12 fw-medium text-danger"
                  ><i class="fa-solid fa-caret-down me-1"></i>-11.2%</span
                >
              </h3>
              <a href="candidates.html" class="link-default">View All</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Widget Info -->

    <!-- Anniversary -->
    <div class="col-xxl-4 col-xl-6 d-flex align-items-start">
      <div class="card flex-fill">
        <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
          <h5 class="mb-2">Work Anniversaries</h5>
          <a
            *ngIf="
              todayAnniversaries.length !== 0 ||
              tomorrowAnniversaries.length !== 0 ||
              upcomingAnniversaries.length !== 0
            "
            [routerLink]="eps.event.anniversaryPath"
            class="btn btn-light btn-md mb-2"
            >View All</a
          >
        </div>
        <ng-container
          *ngIf="
            todayAnniversaries.length !== 0 ||
              tomorrowAnniversaries.length !== 0 ||
              upcomingAnniversaries.length !== 0;
            else noRecords
          "
        >
          <div class="card-body pb-1">
            <!-- ================= TODAY ================= -->
            <h6 *ngIf="todayAnniversaries.length !== 0" class="mb-2">Today</h6>

            <div
              *ngFor="let user of todayAnniversaries"
              class="bg-light p-2 border border-dashed rounded-top mb-3"
            >
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <span class="avatar">
                    <img
                      *ngIf="user.picture; else noAvatar"
                      [src]="apiEndpoint + '/uploads/' + user.picture"
                      class="rounded-circle border border-2"
                    />

                    <ng-template #noAvatar>
                      <span
                        class="avatar avatar-sm rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white"
                        style="width: 32px; height: 32px"
                      >
                        {{ user.firstName.charAt(0) }}
                      </span>
                    </ng-template>
                  </span>

                  <div class="ms-2 overflow-hidden">
                    <h6 class="fs-medium">{{ user.firstName }} {{ user.lastName }}</h6>
                    <p class="fs-13">{{ user.designation?.designationName || '—' }}</p>
                  </div>
                </div>

                <button class="btn btn-success btn-xs">
                  <i class="ti ti-confetti me-1"></i>Wish
                </button>
              </div>
            </div>

            <!-- ================= TOMORROW ================= -->
            <h6 *ngIf="tomorrowAnniversaries.length !== 0" class="mb-2">Tomorrow</h6>

            <div
              *ngFor="let user of tomorrowAnniversaries"
              class="bg-light p-2 border border-dashed rounded-top mb-3"
            >
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <span class="avatar">
                    <img
                      *ngIf="user.picture; else noAvatar"
                      [src]="apiEndpoint + '/uploads/' + user.picture"
                      class="rounded-circle border border-2"
                    />

                    <ng-template #noAvatar>
                      <span
                        class="avatar avatar-sm rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white"
                        style="width: 32px; height: 32px"
                      >
                        {{ user.firstName.charAt(0) }}
                      </span>
                    </ng-template>
                  </span>

                  <div class="ms-2 overflow-hidden">
                    <h6 class="fs-medium">{{ user.firstName }} {{ user.lastName }}</h6>
                    <p class="fs-13">{{ user.designation?.designationName || '—' }}</p>
                  </div>
                </div>

                <button class="btn btn-success btn-xs">
                  <i class="ti ti-confetti me-1"></i>Wish
                </button>
              </div>
            </div>

            <!-- ================= UPCOMING ================= -->
            <h6 *ngIf="upcomingAnniversaries.length !== 0" class="mb-2">Upcoming</h6>

            <div
              *ngFor="let user of upcomingAnniversaries"
              class="bg-light p-2 border border-dashed rounded-top mb-3"
            >
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <span class="avatar">
                    <ng-container *ngIf="user.picture; else noAvatar">
                      <img
                        [src]="apiEndpoint + '/uploads/' + user.picture"
                        class="rounded-circle border border-2"
                        alt="img"
                      />
                    </ng-container>

                    <ng-template #noAvatar>
                      <span
                        class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                        style="width: 40px; height: 40px"
                      >
                        {{ user.firstName.charAt(0) }}
                      </span>
                    </ng-template>
                  </span>

                  <div class="ms-2 overflow-hidden">
                    <h6 class="fs-medium d-flex align-items-center gap-2">
                      {{ user.firstName }} {{ user.lastName }}

                      <!-- 📅 Anniversary Date -->
                      <span class="badge bg-soft-success text-success fs-10">
                        {{ formatAnniversary(user.joiningDate) }}
                      </span>

                      <!-- 🏆 Years Completed -->
                      <span class="badge bg-warning text-dark fs-10">
                        {{ getWorkYears(user.joiningDate) }} yrs
                      </span>
                    </h6>

                    <p class="fs-13">{{ user.designation?.designationName || '—' }}</p>
                  </div>
                </div>

                <button class="btn btn-success btn-xs">
                  <i class="ti ti-confetti me-1"></i>Wish
                </button>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #noRecords>
          <div class="text-center">Record not available</div>
        </ng-template>
      </div>
    </div>

    <!-- / -->
  </div>

  <div class="row">
    <!-- Total Employee -->
    <div class="col-xxl-4 d-flex">
      <div class="card flex-fill">
        <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
          <h5 class="mb-2">Employee Status</h5>
          <!-- <div class="dropdown mb-2">
              <a href="javascript:void(0);" class="btn btn-white border btn-sm d-inline-flex align-items-center"
                data-bs-toggle="dropdown">
                <i class="ti ti-calendar me-1"></i>{{selectedFilterStatusLabel}}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a (click)="changeFilter('month','employee status')" class="dropdown-item rounded-1">This Month</a>
                </li>
                <li>
                  <a (click)="changeFilter('week','employee status')" class="dropdown-item rounded-1">This Week</a>
                </li>
                <li>
                  <a (click)="changeFilter('today','employee status')" class="dropdown-item rounded-1">Today</a>
                </li>
              </ul>
            </div> -->
        </div>
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between mb-1">
            <p class="fs-13 mb-3">Total Employee</p>
            <h3 class="mb-3">{{ employeeCount }}</h3>
          </div>
          <div class="progress-stacked emp-stack mb-3">
            <!-- Full Time -->
            <div
              class="progress"
              role="progressbar"
              [style.width.%]="employeeStats.fullTime.percentage"
            >
              <div class="progress-bar bg-warning"></div>
            </div>
            <!-- Contract -->
            <div
              class="progress"
              role="progressbar"
              [style.width.%]="employeeStats.contract.percentage"
            >
              <div class="progress-bar bg-secondary"></div>
            </div>
            <!-- Probation -->
            <div
              class="progress"
              role="progressbar"
              [style.width.%]="employeeStats.probation.percentage"
            >
              <div class="progress-bar bg-danger"></div>
            </div>
            <div
              class="progress"
              role="progressbar"
              aria-label="Segment four"
              aria-valuenow="20"
              aria-valuemin="0"
              aria-valuemax="100"
              style="width: 30%"
            >
              <div class="progress-bar bg-pink"></div>
            </div>
          </div>
          <div class="border mb-3">
            <div class="row gx-0">
              <div class="col-6">
                <div class="p-2 flex-fill border-end border-bottom">
                  <p class="fs-13 mb-2">
                    <i class="ti ti-square-filled text-primary fs-12 me-2"></i>Fulltime
                    <span class="text-gray-9"> ({{ employeeStats.fullTime.percentage }}%) </span>
                  </p>
                  <h2 class="display-1">{{ employeeStats.fullTime.count }}</h2>
                </div>
              </div>
              <div class="col-6">
                <div class="p-2 flex-fill border-bottom text-end">
                  <p class="fs-13 mb-2">
                    <i class="ti ti-square-filled me-2 text-secondary fs-12"></i>Contract
                    <span class="text-gray-9"> ({{ employeeStats.contract.percentage }}%) </span>
                  </p>
                  <h2 class="display-1">{{ employeeStats.contract.count }}</h2>
                </div>
              </div>
              <div class="col-6">
                <div class="p-2 flex-fill border-end">
                  <p class="fs-13 mb-2">
                    <i class="ti ti-square-filled me-2 text-danger fs-12"></i>Probation
                    <span class="text-gray-9"> ({{ employeeStats.probation.percentage }}%) </span>
                  </p>
                  <h2 class="display-1">{{ employeeStats.probation.count }}</h2>
                </div>
              </div>
              <div class="col-6">
                <div class="p-2 flex-fill text-end">
                  <p class="fs-13 mb-2">
                    <i class="ti ti-square-filled text-pink me-2 fs-12"></i>WFH
                    <span class="text-gray-9">(20%)</span><span class="text-danger">*</span>
                  </p>
                  <h2 class="display-1">04</h2>
                </div>
              </div>
            </div>
          </div>
          <h6 class="mb-2">Top Performer <span class="text-danger">*</span></h6>
          <div
            class="p-2 d-flex align-items-center justify-content-between border border-primary bg-primary-100 br-5 mb-4"
          >
            <div class="d-flex align-items-center overflow-hidden">
              <span class="me-2">
                <i class="ti ti-award-filled text-primary fs-24"></i>
              </span>
              <a href="employee-details.html" class="avatar avatar-md me-2">
                <img
                  src="assets/img/profiles/avatar-24.jpg"
                  class="rounded-circle border border-white"
                  alt="img"
                />
              </a>
              <div>
                <h6 class="text-truncate mb-1 fs-14 fw-medium">
                  <a href="employee-details.html">Daniel Esbella</a>
                </h6>
                <p class="fs-13">IOS Developer</p>
              </div>
            </div>
            <div class="text-end">
              <p class="fs-13 mb-1">Performance</p>
              <h5 class="text-primary">99%</h5>
            </div>
          </div>
          <a [routerLink]="eps.hrm.employeePath" class="btn btn-light btn-md w-100"
            >View All Employees</a
          >
        </div>
      </div>
    </div>
    <!-- /Total Employee -->

    <!-- Attendance Overview -->
    <div class="col-xxl-4 col-xl-6 d-flex">
      <div class="card flex-fill">
        <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
          <h5 class="mb-2">Attendance Overview</h5>
          <div class="dropdown mb-2">
            <a
              href="javascript:void(0);"
              class="btn btn-white border btn-sm d-inline-flex align-items-center"
              data-bs-toggle="dropdown"
            >
              <i class="ti ti-calendar me-1"></i>{{ selectedFilterOverviewLabel }}
            </a>
            <ul class="dropdown-menu dropdown-menu-end p-3">
              <li>
                <a
                  (click)="changeFilter('month', 'attendance overview')"
                  class="dropdown-item rounded-1"
                  >This Month</a
                >
              </li>
              <li>
                <a
                  (click)="changeFilter('week', 'attendance overview')"
                  class="dropdown-item rounded-1"
                  >This Week</a
                >
              </li>
              <li>
                <a
                  (click)="changeFilter('today', 'attendance overview')"
                  class="dropdown-item rounded-1"
                  >Today</a
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="card-body">
          <div class="chartjs-wrapper-demo position-relative mb-4">
            <div class="chartjs-wrapper-demo position-relative mb-4">
              <!-- <canvas id="attendance" height="200"></canvas> -->
              <div class="gauge-container">
                <canvas #attendanceCanvas width="420" height="140"></canvas>
                <div
                  class="tooltip-attendance"
                  *ngIf="tooltip.show"
                  [style.left.px]="tooltip.x"
                  [style.top.px]="tooltip.y"
                >
                  {{ tooltip.label }} — {{ tooltip.value }}%
                </div>
              </div>
              <!-- <div class="position-absolute text-center attendance-canvas">
                  <p class="fs-13 mb-1">Total Attendance</p>
                  <h3>{{ total }}</h3>
                </div> -->
            </div>
          </div>
          <h6 class="mb-3">Status</h6>
          <div class="d-flex justify-content-between">
            <p><i class="ti ti-circle-filled text-success"></i> Present</p>
            <p>{{ presentCount }} ({{ present }}%)</p>
          </div>

          <div class="d-flex justify-content-between">
            <p><i class="ti ti-circle-filled text-secondary"></i> Late</p>
            <p>{{ lateCount }} ({{ late }}%)</p>
          </div>

          <div class="d-flex justify-content-between">
            <p><i class="ti ti-circle-filled text-warning"></i> Leaves</p>
            <p>{{ leaveCount }} ({{ leave }}%)</p>
          </div>

          <div class="d-flex justify-content-between">
            <p><i class="ti ti-circle-filled text-danger"></i> Absent</p>
            <p>{{ absentCount }} ({{ absent }}%)</p>
          </div>

          <div
            class="bg-light br-5 box-shadow-xs p-2 pb-0 d-flex align-items-center justify-content-between flex-wrap"
          >
            <div class="d-flex align-items-center">
              <p class="mb-2 me-2">Total Absenties</p>
              <div class="avatar-list-stacked avatar-group-sm mb-2">
                <span class="avatar avatar-rounded">
                  <img
                    class="border border-white"
                    src="assets/img/profiles/avatar-27.jpg"
                    alt="img"
                  />
                </span>
                <span class="avatar avatar-rounded">
                  <img
                    class="border border-white"
                    src="assets/img/profiles/avatar-30.jpg"
                    alt="img"
                  />
                </span>
                <span class="avatar avatar-rounded">
                  <img src="assets/img/profiles/avatar-14.jpg" alt="img" />
                </span>
                <span class="avatar avatar-rounded">
                  <img src="assets/img/profiles/avatar-29.jpg" alt="img" />
                </span>
                <a
                  class="avatar bg-primary avatar-rounded text-fixed-white fs-10"
                  href="javascript:void(0);"
                >
                  +1
                </a>
              </div>
            </div>
            <a
              [routerLink]="eps.attendance.attendanceListPath"
              class="fs-13 link-primary text-decoration-underline mb-2"
              >View Details</a
            >
          </div>
        </div>
      </div>
    </div>
    <!-- /Attendance Overview -->

    <!-- Clock-In/Out -->
    <div class="col-xxl-4 col-xl-6 d-flex">
      <div class="card flex-fill">
        <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
          <h5 class="mb-2">Clock-In/Out</h5>
          <!-- <div class="d-flex align-items-center">
              <div class="dropdown mb-2">
                <a href="javascript:void(0);"
                  class="dropdown-toggle btn btn-white btn-sm d-inline-flex align-items-center border-0 fs-13 me-2"
                  data-bs-toggle="dropdown">
                  All Departments
                </a>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1">Finance</a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1">Development</a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1">Marketing</a>
                  </li>
                </ul>
              </div>
              <div class="dropdown mb-2">
                <a href="javascript:void(0);" class="btn btn-white border btn-sm d-inline-flex align-items-center"
                  data-bs-toggle="dropdown">
                  <i class="ti ti-calendar me-1"></i>{{selectedFilterClockInOutLabel}}
                </a>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <a (click)="changeFilter('month','clock in out')" class="dropdown-item rounded-1">This Month</a>
                  </li>
                  <li>
                    <a (click)="changeFilter('week','clock in out')" class="dropdown-item rounded-1">This Week</a>
                  </li>
                  <li>
                    <a (click)="changeFilter('today','clock in out')" class="dropdown-item rounded-1">Today</a>
                  </li>
                </ul>
              </div>
            </div> -->
        </div>
        <div class="card-body">
          <!-- On-Time Users -->
          <div *ngFor="let user of onTimeUsers" class="mb-3 p-2 border br-5">
            <div
              class="d-flex align-items-center justify-content-between"
              (click)="toggleUserDetails(user)"
            >
              <div class="d-flex align-items-center">
                <a href="javascript:void(0);" class="avatar flex-shrink-0">
                  <!-- If avatar exists, show image -->
                  <ng-container *ngIf="user.avatar; else noAvatar">
                    <img
                      [src]="apiEndpoint + '/uploads/' + user.avatar"
                      class="rounded-circle border border-2"
                      alt="img"
                    />
                  </ng-container>

                  <!-- Fallback: first letter of user name -->
                  <ng-template #noAvatar>
                    <span
                      class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                      style="width: 40px; height: 40px"
                    >
                      {{ user.name.charAt(0) }}
                    </span>
                  </ng-template>
                </a>
                <div class="ms-2">
                  <h6 class="fs-14 fw-medium text-truncate">{{ user.name }}</h6>
                  <p class="fs-13">{{ user.department }}</p>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <a href="javascript:void(0);" class="link-default me-2"
                  ><i class="ti ti-clock-share"></i
                ></a>
                <span class="fs-10 fw-medium d-inline-flex align-items-center badge badge-success">
                  <i class="ti ti-circle-filled fs-5 me-1"></i
                  >{{ user.firstClockIn | date: 'shortTime' }}
                </span>
              </div>
            </div>

            <!-- Expanded Details -->
            <div
              *ngIf="expandedUser === user.id"
              class="d-flex align-items-center justify-content-between flex-wrap mt-2 border br-5 p-2 pb-0"
            >
              <div>
                <p class="mb-1 d-inline-flex align-items-center">
                  <i class="ti ti-circle-filled text-success fs-5 me-1"></i>Clock In
                </p>
                <h6 class="fs-13 fw-normal mb-2">
                  {{ user.firstClockIn | date: 'shortTime' }}
                </h6>
              </div>
              <div>
                <p class="mb-1 d-inline-flex align-items-center">
                  <i class="ti ti-circle-filled text-danger fs-5 me-1"></i>Clock Out
                </p>
                <h6 class="fs-13 fw-normal mb-2">
                  {{ user.lastClockOut ? (user.lastClockOut | date: 'shortTime') : 'Continue' }}
                </h6>
              </div>
              <div *ngIf="user.totalWorkHours">
                <p class="mb-1 d-inline-flex align-items-center">
                  <i class="ti ti-circle-filled text-warning fs-5 me-1"></i>Production
                </p>
                <h6 class="fs-13 fw-normal mb-2">{{ user.totalWorkHours }}</h6>
              </div>
            </div>
          </div>

          <!-- Late Users -->
          <h6 class="mb-2 mt-3" *ngIf="lateUsers.length !== 0">Late</h6>
          <div *ngFor="let user of lateUsers" class="mb-3 p-2 border border-dashed br-5">
            <!-- Main Row -->
            <div
              class="d-flex align-items-center justify-content-between"
              (click)="toggleUserDetails(user)"
            >
              <div class="d-flex align-items-center">
                <a href="javascript:void(0);" class="avatar flex-shrink-0">
                  <ng-container *ngIf="user.avatar; else noAvatarLate">
                    <img
                      [src]="apiEndpoint + '/uploads/' + user.avatar"
                      class="rounded-circle border border-2"
                      alt="img"
                    />
                  </ng-container>

                  <ng-template #noAvatarLate>
                    <span
                      class="avatar avatar-sm rounded-circle d-inline-flex align-items-center justify-content-center bg-danger text-white"
                      style="width: 32px; height: 32px"
                    >
                      {{ user.name.charAt(0) }}
                    </span>
                  </ng-template>
                </a>

                <div class="ms-2">
                  <h6 class="fs-14 fw-medium text-truncate">
                    {{ user.name }}
                    <span class="badge badge-danger ms-1">
                      <i class="ti ti-clock-hour-11 me-1"></i>{{ user.lateDuration }}
                    </span>
                  </h6>
                  <p class="fs-13">{{ user.department }}</p>
                </div>
              </div>

              <div class="d-flex align-items-center">
                <a href="javascript:void(0);" class="link-default me-2">
                  <i class="ti ti-clock-share"></i>
                </a>
                <span class="fs-10 fw-medium badge badge-danger">
                  <i class="ti ti-circle-filled fs-5 me-1"></i>
                  {{ user.firstClockIn | date: 'shortTime' }}
                </span>
              </div>
            </div>

            <!-- Expanded Details (SAME AS ON-TIME) -->
            <div
              *ngIf="expandedUser === user.id"
              class="d-flex align-items-center justify-content-between flex-wrap mt-2 border br-5 p-2 pb-0"
            >
              <div>
                <p class="mb-1"><i class="ti ti-circle-filled text-success me-1"></i>Clock In</p>
                <h6 class="fs-13 fw-normal mb-2">
                  {{ user.firstClockIn | date: 'shortTime' }}
                </h6>
              </div>

              <div>
                <p class="mb-1"><i class="ti ti-circle-filled text-danger me-1"></i>Clock Out</p>
                <h6 class="fs-13 fw-normal mb-2">
                  {{ user.lastClockOut ? (user.lastClockOut | date: 'shortTime') : 'Continue' }}
                </h6>
              </div>

              <div *ngIf="user.totalWorkHours">
                <p class="mb-1"><i class="ti ti-circle-filled text-warning me-1"></i>Production</p>
                <h6 class="fs-13 fw-normal mb-2">{{ user.totalWorkHours }}</h6>
              </div>
            </div>
          </div>

          <!-- View All Button -->
          <a [routerLink]="eps.attendance.attendanceListPath" class="btn btn-light btn-md w-100">
            View All Attendance
          </a>
        </div>
      </div>
      <!-- /Clock-In/Out -->
    </div>

    <!-- <div class="row"> -->
    <!-- Jobs Applicants -->
    <div class="col-xxl-4 d-flex">
      <div class="card flex-fill">
        <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
          <h5 class="mb-2">Jobs Applicants</h5>
          <a href="job-list.html" class="btn btn-light btn-md mb-2">View All</a>
        </div>
        <div class="card-body">
          <ul
            class="nav nav-tabs tab-style-1 nav-justified d-sm-flex d-block p-0 mb-4"
            role="tablist"
          >
            <li class="nav-item" role="presentation">
              <a
                class="nav-link fw-medium"
                data-bs-toggle="tab"
                data-bs-target="#openings"
                aria-current="page"
                href="#openings"
                aria-selected="true"
                role="tab"
                >Openings</a
              >
            </li>
            <li class="nav-item" role="presentation">
              <a
                class="nav-link fw-medium active"
                data-bs-toggle="tab"
                data-bs-target="#applicants"
                href="#applicants"
                aria-selected="false"
                tabindex="-1"
                role="tab"
                >Applicants</a
              >
            </li>
          </ul>
          <div class="tab-content">
            <div class="tab-pane fade" id="openings">
              <div class="d-flex align-items-center justify-content-between mb-4">
                <div class="d-flex align-items-center">
                  <a href="#" class="avatar overflow-hidden flex-shrink-0 bg-gray-100">
                    <img
                      src="assets/img/icons/apple.svg"
                      class="img-fluid rounded-circle w-auto h-auto"
                      alt="img"
                    />
                  </a>
                  <div class="ms-2 overflow-hidden">
                    <p class="text-dark fw-medium text-truncate mb-0">
                      <a href="javascript:void(0);">Senior IOS Developer</a>
                    </p>
                    <span class="fs-12">No of Openings : 25 </span>
                  </div>
                </div>
                <a
                  href="javascript:void(0);"
                  class="btn btn-light btn-sm p-0 btn-icon d-flex align-items-center justify-content-center"
                  ><i class="ti ti-edit"></i
                ></a>
              </div>
              <div class="d-flex align-items-center justify-content-between mb-4">
                <div class="d-flex align-items-center">
                  <a href="#" class="avatar overflow-hidden flex-shrink-0 bg-gray-100">
                    <img src="assets/img/icons/php.svg" class="img-fluid w-auto h-auto" alt="img" />
                  </a>
                  <div class="ms-2 overflow-hidden">
                    <p class="text-dark fw-medium text-truncate mb-0">
                      <a href="javascript:void(0);">Junior PHP Developer</a>
                    </p>
                    <span class="fs-12">No of Openings : 20 </span>
                  </div>
                </div>
                <a
                  href="javascript:void(0);"
                  class="btn btn-light btn-sm p-0 btn-icon d-flex align-items-center justify-content-center"
                  ><i class="ti ti-edit"></i
                ></a>
              </div>
              <div class="d-flex align-items-center justify-content-between mb-4">
                <div class="d-flex align-items-center">
                  <a href="#" class="avatar overflow-hidden flex-shrink-0 bg-gray-100">
                    <img
                      src="assets/img/icons/react.svg"
                      class="img-fluid w-auto h-auto"
                      alt="img"
                    />
                  </a>
                  <div class="ms-2 overflow-hidden">
                    <p class="text-dark fw-medium text-truncate mb-0">
                      <a href="javascript:void(0);">Junior React Developer </a>
                    </p>
                    <span class="fs-12">No of Openings : 30 </span>
                  </div>
                </div>
                <a
                  href="javascript:void(0);"
                  class="btn btn-light btn-sm p-0 btn-icon d-flex align-items-center justify-content-center"
                  ><i class="ti ti-edit"></i
                ></a>
              </div>
              <div class="d-flex align-items-center justify-content-between mb-0">
                <div class="d-flex align-items-center">
                  <a href="#" class="avatar overflow-hidden flex-shrink-0 bg-gray-100">
                    <img
                      src="assets/img/icons/laravel-icon.svg"
                      class="img-fluid w-auto h-auto"
                      alt="img"
                    />
                  </a>
                  <div class="ms-2 overflow-hidden">
                    <p class="text-dark fw-medium text-truncate mb-0">
                      <a href="javascript:void(0);">Senior Laravel Developer</a>
                    </p>
                    <span class="fs-12">No of Openings : 40 </span>
                  </div>
                </div>
                <a
                  href="javascript:void(0);"
                  class="btn btn-light btn-sm p-0 btn-icon d-flex align-items-center justify-content-center"
                  ><i class="ti ti-edit"></i
                ></a>
              </div>
            </div>
            <div class="tab-pane fade show active" id="applicants">
              <div class="d-flex align-items-center justify-content-between mb-4">
                <div class="d-flex align-items-center">
                  <a href="#" class="avatar overflow-hidden flex-shrink-0">
                    <img
                      src="assets/img/users/user-09.jpg"
                      class="img-fluid rounded-circle"
                      alt="img"
                    />
                  </a>
                  <div class="ms-2 overflow-hidden">
                    <p class="text-dark fw-medium text-truncate mb-0">
                      <a href="#">Brian Villalobos</a>
                    </p>
                    <span class="fs-13 d-inline-flex align-items-center"
                      >Exp : 5+ Years<i class="ti ti-circle-filled fs-4 mx-2 text-primary"></i
                      >USA</span
                    >
                  </div>
                </div>
                <span class="badge badge-secondary badge-xs">UI/UX Designer</span>
              </div>
              <div class="d-flex align-items-center justify-content-between mb-4">
                <div class="d-flex align-items-center">
                  <a href="#" class="avatar overflow-hidden flex-shrink-0">
                    <img
                      src="assets/img/users/user-32.jpg"
                      class="img-fluid rounded-circle"
                      alt="img"
                    />
                  </a>
                  <div class="ms-2 overflow-hidden">
                    <p class="text-dark fw-medium text-truncate mb-0">
                      <a href="#">Anthony Lewis</a>
                    </p>
                    <span class="fs-13 d-inline-flex align-items-center"
                      >Exp : 4+ Years<i class="ti ti-circle-filled fs-4 mx-2 text-primary"></i
                      >USA</span
                    >
                  </div>
                </div>
                <span class="badge badge-info badge-xs">Python Developer</span>
              </div>
              <div class="d-flex align-items-center justify-content-between mb-4">
                <div class="d-flex align-items-center">
                  <a href="#" class="avatar overflow-hidden flex-shrink-0">
                    <img
                      src="assets/img/users/user-32.jpg"
                      class="img-fluid rounded-circle"
                      alt="img"
                    />
                  </a>
                  <div class="ms-2 overflow-hidden">
                    <p class="text-dark fw-medium text-truncate mb-0">
                      <a href="#">Stephan Peralt</a>
                    </p>
                    <span class="fs-13 d-inline-flex align-items-center"
                      >Exp : 6+ Years<i class="ti ti-circle-filled fs-4 mx-2 text-primary"></i
                      >USA</span
                    >
                  </div>
                </div>
                <span class="badge badge-pink badge-xs">Android Developer</span>
              </div>
              <div class="d-flex align-items-center justify-content-between mb-0">
                <div class="d-flex align-items-center">
                  <a href="javascript:void(0);" class="avatar overflow-hidden flex-shrink-0">
                    <img
                      src="assets/img/users/user-34.jpg"
                      class="img-fluid rounded-circle"
                      alt="img"
                    />
                  </a>
                  <div class="ms-2 overflow-hidden">
                    <p class="text-dark fw-medium text-truncate mb-0">
                      <a href="javascript:void(0);">Doglas Martini</a>
                    </p>
                    <span class="fs-13 d-inline-flex align-items-center"
                      >Exp : 2+ Years<i class="ti ti-circle-filled fs-4 mx-2 text-primary"></i
                      >USA</span
                    >
                  </div>
                </div>
                <span class="badge badge-purple badge-xs">React Developer</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Jobs Applicants -->

    <!-- Employees -->
    <div class="col-xxl-4 col-xl-6 d-flex">
      <div class="card flex-fill">
        <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
          <h5 class="mb-2">Employees</h5>
          <a [routerLink]="eps.hrm.employeePath" class="btn btn-light btn-md mb-2">View All</a>
        </div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-nowrap mb-0">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Department</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let user of employees">
                  <td>
                    <div class="d-flex align-items-center">
                      <span class="avatar me-2">
                        <ng-container *ngIf="user.picture; else noAvatar">
                          <img
                            [src]="apiEndpoint + '/uploads/' + user.picture"
                            class="rounded-circle border border-2"
                            alt="img"
                          />
                        </ng-container>

                        <ng-template #noAvatar>
                          <span
                            class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                            style="width: 40px; height: 40px"
                          >
                            {{ user.firstName.charAt(0) }}
                          </span>
                        </ng-template>
                      </span>

                      <div>
                        <h6 class="fw-medium mb-0">{{ user.firstName }} {{ user.lastName }}</h6>
                        <span class="fs-12 text-muted">
                          {{ user.designationName || 'No Designation' }}
                        </span>
                      </div>
                    </div>
                  </td>

                  <td>
                    <span class="badge badge-secondary-transparent badge-xs">
                      {{ user.departmentName || 'N/A' }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- /Employees -->

    <!-- Todo -->
    <div class="col-xxl-4 col-xl-6 d-flex">
      <div class="card flex-fill">
        <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
          <h5 class="mb-2">Todo</h5>
          <div class="d-flex align-items-center">
            <div class="dropdown mb-2 me-2">
              <a
                href="javascript:void(0);"
                class="btn btn-white border btn-sm d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-calendar me-1"></i>Today
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">This Month</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">This Week</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">Today</a>
                </li>
              </ul>
            </div>
            <a
              href="#"
              class="btn btn-primary btn-icon btn-xs rounded-circle d-flex align-items-center justify-content-center p-0 mb-2"
              data-bs-toggle="modal"
              data-bs-target="#add_todo"
              ><i class="ti ti-plus fs-16"></i
            ></a>
          </div>
        </div>
        <div class="card-body">
          <div class="d-flex align-items-center todo-item border p-2 br-5 mb-2">
            <i class="ti ti-grid-dots me-2"></i>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="todo1" />
              <label class="form-check-label fw-medium" for="todo1">Add Holidays</label>
            </div>
          </div>
          <div class="d-flex align-items-center todo-item border p-2 br-5 mb-2">
            <i class="ti ti-grid-dots me-2"></i>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="todo2" />
              <label class="form-check-label fw-medium" for="todo2">Add Meeting to Client</label>
            </div>
          </div>
          <div class="d-flex align-items-center todo-item border p-2 br-5 mb-2">
            <i class="ti ti-grid-dots me-2"></i>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="todo3" />
              <label class="form-check-label fw-medium" for="todo3">Chat with Adrian</label>
            </div>
          </div>
          <div class="d-flex align-items-center todo-item border p-2 br-5 mb-2">
            <i class="ti ti-grid-dots me-2"></i>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="todo4" />
              <label class="form-check-label fw-medium" for="todo4">Management Call</label>
            </div>
          </div>
          <div class="d-flex align-items-center todo-item border p-2 br-5 mb-2">
            <i class="ti ti-grid-dots me-2"></i>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="todo5" />
              <label class="form-check-label fw-medium" for="todo5">Add Payroll</label>
            </div>
          </div>
          <div class="d-flex align-items-center todo-item border p-2 br-5 mb-0">
            <i class="ti ti-grid-dots me-2"></i>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="todo6" />
              <label class="form-check-label fw-medium" for="todo6"
                >Add Policy for Increment
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Todo -->
    <!-- </div> -->

    <!-- <div class="row"> -->
    <!-- Sales Overview -->
    <div class="col-xl-7 d-flex">
      <div class="card flex-fill">
        <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
          <h5 class="mb-2">Sales Overview</h5>
          <div class="d-flex align-items-center">
            <div class="dropdown mb-2">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white border-0 btn-sm d-inline-flex align-items-center fs-13 me-2"
                data-bs-toggle="dropdown"
              >
                All Departments
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">UI/UX Designer</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">HR Manager</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">Junior Tester</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-body pb-0">
          <div class="d-flex align-items-center justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-1">
              <p class="fs-13 text-gray-9 me-3 mb-0">
                <i class="ti ti-square-filled me-2 text-primary"></i>Income
              </p>
              <p class="fs-13 text-gray-9 mb-0">
                <i class="ti ti-square-filled me-2 text-gray-2"></i>Expenses
              </p>
            </div>
            <p class="fs-13 mb-1">Last Updated at 11:30PM</p>
          </div>
          <div id="sales-income"></div>
        </div>
      </div>
    </div>
    <!-- /Sales Overview -->

    <!-- Invoices -->
    <div class="col-xl-5 d-flex">
      <div class="card flex-fill">
        <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
          <h5 class="mb-2">Invoices</h5>
          <div class="d-flex align-items-center">
            <div class="dropdown mb-2">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white btn-sm d-inline-flex align-items-center fs-13 me-2 border-0"
                data-bs-toggle="dropdown"
              >
                Invoices
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">Invoices</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">Paid</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">Unpaid</a>
                </li>
              </ul>
            </div>
            <div class="dropdown mb-2">
              <a
                href="javascript:void(0);"
                class="btn btn-white border btn-sm d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-calendar me-1"></i>This Week
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">This Month</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">This Week</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">Today</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-body pt-2">
          <div class="table-responsive pt-1">
            <table class="table table-nowrap table-borderless mb-0">
              <tbody>
                <tr>
                  <td class="px-0">
                    <div class="d-flex align-items-center">
                      <a href="invoice-details.html" class="avatar">
                        <img
                          src="assets/img/users/user-39.jpg"
                          class="img-fluid rounded-circle"
                          alt="img"
                        />
                      </a>
                      <div class="ms-2">
                        <h6 class="fw-medium">
                          <a href="invoice-details.html">Redesign Website</a>
                        </h6>
                        <span class="fs-13 d-inline-flex align-items-center"
                          >#INVOO2<i class="ti ti-circle-filled fs-4 mx-1 text-primary"></i
                          >Logistics</span
                        >
                      </div>
                    </div>
                  </td>
                  <td>
                    <p class="fs-13 mb-1">Payment</p>
                    <h6 class="fw-medium">$3560</h6>
                  </td>
                  <td class="px-0 text-end">
                    <span
                      class="badge badge-danger-transparent badge-xs d-inline-flex align-items-center"
                      ><i class="ti ti-circle-filled fs-5 me-1"></i>Unpaid</span
                    >
                  </td>
                </tr>
                <tr>
                  <td class="px-0">
                    <div class="d-flex align-items-center">
                      <a href="invoice-details.html" class="avatar">
                        <img
                          src="assets/img/users/user-40.jpg"
                          class="img-fluid rounded-circle"
                          alt="img"
                        />
                      </a>
                      <div class="ms-2">
                        <h6 class="fw-medium">
                          <a href="invoice-details.html">Module Completion</a>
                        </h6>
                        <span class="fs-13 d-inline-flex align-items-center"
                          >#INVOO5<i class="ti ti-circle-filled fs-4 mx-1 text-primary"></i>Yip
                          Corp</span
                        >
                      </div>
                    </div>
                  </td>
                  <td>
                    <p class="fs-13 mb-1">Payment</p>
                    <h6 class="fw-medium">$4175</h6>
                  </td>
                  <td class="px-0 text-end">
                    <span
                      class="badge badge-danger-transparent badge-xs d-inline-flex align-items-center"
                      ><i class="ti ti-circle-filled fs-5 me-1"></i>Unpaid</span
                    >
                  </td>
                </tr>
                <tr>
                  <td class="px-0">
                    <div class="d-flex align-items-center">
                      <a href="invoice-details.html" class="avatar">
                        <img
                          src="assets/img/users/user-55.jpg"
                          class="img-fluid rounded-circle"
                          alt="img"
                        />
                      </a>
                      <div class="ms-2">
                        <h6 class="fw-medium">
                          <a href="invoice-details.html">Change on Emp Module</a>
                        </h6>
                        <span class="fs-13 d-inline-flex align-items-center"
                          >#INVOO3<i class="ti ti-circle-filled fs-4 mx-1 text-primary"></i>Ignis
                          LLP</span
                        >
                      </div>
                    </div>
                  </td>
                  <td>
                    <p class="fs-13 mb-1">Payment</p>
                    <h6 class="fw-medium">$6985</h6>
                  </td>
                  <td class="px-0 text-end">
                    <span
                      class="badge badge-danger-transparent badge-xs d-inline-flex align-items-center"
                      ><i class="ti ti-circle-filled fs-5 me-1"></i>Unpaid</span
                    >
                  </td>
                </tr>
                <tr>
                  <td class="px-0">
                    <div class="d-flex align-items-center">
                      <a href="invoice-details.html" class="avatar">
                        <img
                          src="assets/img/users/user-42.jpg"
                          class="img-fluid rounded-circle"
                          alt="img"
                        />
                      </a>
                      <div class="ms-2">
                        <h6 class="fw-medium">
                          <a href="invoice-details.html">Changes on the Board</a>
                        </h6>
                        <span class="fs-13 d-inline-flex align-items-center"
                          >#INVOO2<i class="ti ti-circle-filled fs-4 mx-1 text-primary"></i>Ignis
                          LLP</span
                        >
                      </div>
                    </div>
                  </td>
                  <td>
                    <p class="fs-13 mb-1">Payment</p>
                    <h6 class="fw-medium">$1457</h6>
                  </td>
                  <td class="px-0 text-end">
                    <span
                      class="badge badge-danger-transparent badge-xs d-inline-flex align-items-center"
                      ><i class="ti ti-circle-filled fs-5 me-1"></i>Unpaid</span
                    >
                  </td>
                </tr>
                <tr>
                  <td class="px-0">
                    <div class="d-flex align-items-center">
                      <a href="invoice-details.html" class="avatar">
                        <img
                          src="assets/img/users/user-44.jpg"
                          class="img-fluid rounded-circle"
                          alt="img"
                        />
                      </a>
                      <div class="ms-2">
                        <h6 class="fw-medium">
                          <a href="invoice-details.html">Hospital Management</a>
                        </h6>
                        <span class="fs-13 d-inline-flex align-items-center"
                          >#INVOO6<i class="ti ti-circle-filled fs-4 mx-1 text-primary"></i>HCL
                          Corp</span
                        >
                      </div>
                    </div>
                  </td>
                  <td>
                    <p class="fs-13 mb-1">Payment</p>
                    <h6 class="fw-medium">$6458</h6>
                  </td>
                  <td class="px-0 text-end">
                    <span
                      class="badge badge-success-transparent badge-xs d-inline-flex align-items-center"
                      ><i class="ti ti-circle-filled fs-5 me-1"></i>Paid</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <a href="invoice.html" class="btn btn-light btn-md w-100 mt-2">View All</a>
        </div>
      </div>
    </div>
    <!-- /Invoices -->
    <!-- </div> -->

    <!-- <div class="row"> -->
    <!-- Projects -->
    <div class="col-xxl-8 col-xl-7 d-flex">
      <div class="card flex-fill">
        <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
          <h5 class="mb-2">Projects</h5>
          <div class="d-flex align-items-center">
            <div class="dropdown mb-2">
              <a
                href="javascript:void(0);"
                class="btn btn-white border btn-sm d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-calendar me-1"></i>This Week
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">This Month</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">This Week</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">Today</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-nowrap mb-0">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Team</th>
                  <th>Hours</th>
                  <th>Deadline</th>
                  <th>Priority</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><a href="project-details.html" class="link-default">PRO-001</a></td>
                  <td>
                    <h6 class="fw-medium">
                      <a href="project-details.html">Office Management App</a>
                    </h6>
                  </td>
                  <td>
                    <div class="avatar-list-stacked avatar-group-sm">
                      <span class="avatar avatar-rounded">
                        <img
                          class="border border-white"
                          src="assets/img/profiles/avatar-02.jpg"
                          alt="img"
                        />
                      </span>
                      <span class="avatar avatar-rounded">
                        <img
                          class="border border-white"
                          src="assets/img/profiles/avatar-03.jpg"
                          alt="img"
                        />
                      </span>
                      <span class="avatar avatar-rounded">
                        <img
                          class="border border-white"
                          src="assets/img/profiles/avatar-05.jpg"
                          alt="img"
                        />
                      </span>
                    </div>
                  </td>
                  <td>
                    <p class="mb-1">15/255 Hrs</p>
                    <div
                      class="progress progress-xs w-100"
                      role="progressbar"
                      aria-valuenow="40"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      <div class="progress-bar bg-primary" style="width: 40%"></div>
                    </div>
                  </td>
                  <td>12 Sep 2024</td>
                  <td>
                    <span class="badge badge-danger d-inline-flex align-items-center badge-xs">
                      <!-- -->
                      High
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><a href="project-details.html" class="link-default">PRO-002</a></td>
                  <td>
                    <h6 class="fw-medium">
                      <a href="project-details.html">Clinic Management </a>
                    </h6>
                  </td>
                  <td>
                    <div class="avatar-list-stacked avatar-group-sm">
                      <span class="avatar avatar-rounded">
                        <img
                          class="border border-white"
                          src="assets/img/profiles/avatar-06.jpg"
                          alt="img"
                        />
                      </span>
                      <span class="avatar avatar-rounded">
                        <img
                          class="border border-white"
                          src="assets/img/profiles/avatar-07.jpg"
                          alt="img"
                        />
                      </span>
                      <span class="avatar avatar-rounded">
                        <img
                          class="border border-white"
                          src="assets/img/profiles/avatar-08.jpg"
                          alt="img"
                        />
                      </span>
                      <a
                        class="avatar bg-primary avatar-rounded text-fixed-white fs-10 fw-medium"
                        href="javascript:void(0);"
                      >
                        +1
                      </a>
                    </div>
                  </td>
                  <td>
                    <p class="mb-1">15/255 Hrs</p>
                    <div
                      class="progress progress-xs w-100"
                      role="progressbar"
                      aria-valuenow="40"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      <div class="progress-bar bg-primary" style="width: 40%"></div>
                    </div>
                  </td>
                  <td>24 Oct 2024</td>
                  <td>
                    <span class="badge badge-success d-inline-flex align-items-center badge-xs">
                      <!-- -->
                      Low
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><a href="project-details.html" class="link-default">PRO-003</a></td>
                  <td>
                    <h6 class="fw-medium">
                      <a href="project-details.html">Educational Platform</a>
                    </h6>
                  </td>
                  <td>
                    <div class="avatar-list-stacked avatar-group-sm">
                      <span class="avatar avatar-rounded">
                        <img
                          class="border border-white"
                          src="assets/img/profiles/avatar-06.jpg"
                          alt="img"
                        />
                      </span>
                      <span class="avatar avatar-rounded">
                        <img
                          class="border border-white"
                          src="assets/img/profiles/avatar-08.jpg"
                          alt="img"
                        />
                      </span>
                      <span class="avatar avatar-rounded">
                        <img
                          class="border border-white"
                          src="assets/img/profiles/avatar-09.jpg"
                          alt="img"
                        />
                      </span>
                    </div>
                  </td>
                  <td>
                    <p class="mb-1">40/255 Hrs</p>
                    <div
                      class="progress progress-xs w-100"
                      role="progressbar"
                      aria-valuenow="50"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      <div class="progress-bar bg-primary" style="width: 50%"></div>
                    </div>
                  </td>
                  <td>18 Feb 2024</td>
                  <td>
                    <span class="badge badge-pink d-inline-flex align-items-center badge-xs">
                      <!-- -->
                      Medium
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><a href="project-details.html" class="link-default">PRO-004</a></td>
                  <td>
                    <h6 class="fw-medium">
                      <a href="project-details.html">Chat & Call Mobile App</a>
                    </h6>
                  </td>
                  <td>
                    <div class="avatar-list-stacked avatar-group-sm">
                      <span class="avatar avatar-rounded">
                        <img
                          class="border border-white"
                          src="assets/img/profiles/avatar-11.jpg"
                          alt="img"
                        />
                      </span>
                      <span class="avatar avatar-rounded">
                        <img
                          class="border border-white"
                          src="assets/img/profiles/avatar-12.jpg"
                          alt="img"
                        />
                      </span>
                      <span class="avatar avatar-rounded">
                        <img
                          class="border border-white"
                          src="assets/img/profiles/avatar-13.jpg"
                          alt="img"
                        />
                      </span>
                    </div>
                  </td>
                  <td>
                    <p class="mb-1">35/155 Hrs</p>
                    <div
                      class="progress progress-xs w-100"
                      role="progressbar"
                      aria-valuenow="50"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      <div class="progress-bar bg-primary" style="width: 50%"></div>
                    </div>
                  </td>
                  <td>19 Feb 2024</td>
                  <td>
                    <span class="badge badge-danger d-inline-flex align-items-center badge-xs">
                      <!-- -->
                      High
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><a href="project-details.html" class="link-default">PRO-005</a></td>
                  <td>
                    <h6 class="fw-medium">
                      <a href="project-details.html">Travel Planning Website</a>
                    </h6>
                  </td>
                  <td>
                    <div class="avatar-list-stacked avatar-group-sm">
                      <span class="avatar avatar-rounded">
                        <img
                          class="border border-white"
                          src="assets/img/profiles/avatar-17.jpg"
                          alt="img"
                        />
                      </span>
                      <span class="avatar avatar-rounded">
                        <img
                          class="border border-white"
                          src="assets/img/profiles/avatar-18.jpg"
                          alt="img"
                        />
                      </span>
                      <span class="avatar avatar-rounded">
                        <img
                          class="border border-white"
                          src="assets/img/profiles/avatar-19.jpg"
                          alt="img"
                        />
                      </span>
                    </div>
                  </td>
                  <td>
                    <p class="mb-1">50/235 Hrs</p>
                    <div
                      class="progress progress-xs w-100"
                      role="progressbar"
                      aria-valuenow="50"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      <div class="progress-bar bg-primary" style="width: 50%"></div>
                    </div>
                  </td>
                  <td>18 Feb 2024</td>
                  <td>
                    <span class="badge badge-pink d-inline-flex align-items-center badge-xs">
                      <!-- -->
                      Medium
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><a href="project-details.html" class="link-default">PRO-006</a></td>
                  <td>
                    <h6 class="fw-medium">
                      <a href="project-details.html">Service Booking Software</a>
                    </h6>
                  </td>
                  <td>
                    <div class="avatar-list-stacked avatar-group-sm">
                      <span class="avatar avatar-rounded">
                        <img
                          class="border border-white"
                          src="assets/img/profiles/avatar-06.jpg"
                          alt="img"
                        />
                      </span>
                      <span class="avatar avatar-rounded">
                        <img
                          class="border border-white"
                          src="assets/img/profiles/avatar-08.jpg"
                          alt="img"
                        />
                      </span>
                      <span class="avatar avatar-rounded">
                        <img
                          class="border border-white"
                          src="assets/img/profiles/avatar-09.jpg"
                          alt="img"
                        />
                      </span>
                    </div>
                  </td>
                  <td>
                    <p class="mb-1">40/255 Hrs</p>
                    <div
                      class="progress progress-xs w-100"
                      role="progressbar"
                      aria-valuenow="50"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      <div class="progress-bar bg-primary" style="width: 50%"></div>
                    </div>
                  </td>
                  <td>20 Feb 2024</td>
                  <td>
                    <span class="badge badge-success d-inline-flex align-items-center badge-xs">
                      <!-- -->
                      Low
                    </span>
                  </td>
                </tr>
                <tr>
                  <td class="border-0">
                    <a href="project-details.html" class="link-default">PRO-008</a>
                  </td>
                  <td class="border-0">
                    <h6 class="fw-medium">
                      <a href="project-details.html">Travel Planning Website</a>
                    </h6>
                  </td>
                  <td class="border-0">
                    <div class="avatar-list-stacked avatar-group-sm">
                      <span class="avatar avatar-rounded">
                        <img
                          class="border border-white"
                          src="assets/img/profiles/avatar-15.jpg"
                          alt="img"
                        />
                      </span>
                      <span class="avatar avatar-rounded">
                        <img
                          class="border border-white"
                          src="assets/img/profiles/avatar-16.jpg"
                          alt="img"
                        />
                      </span>
                      <span class="avatar avatar-rounded">
                        <img
                          class="border border-white"
                          src="assets/img/profiles/avatar-17.jpg"
                          alt="img"
                        />
                      </span>
                      <a
                        class="avatar bg-primary avatar-rounded text-fixed-white fs-10 fw-medium"
                        href="javascript:void(0);"
                      >
                        +2
                      </a>
                    </div>
                  </td>
                  <td class="border-0">
                    <p class="mb-1">15/255 Hrs</p>
                    <div
                      class="progress progress-xs w-100"
                      role="progressbar"
                      aria-valuenow="45"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      <div class="progress-bar bg-primary" style="width: 45%"></div>
                    </div>
                  </td>
                  <td class="border-0">17 Oct 2024</td>
                  <td class="border-0">
                    <span class="badge badge-pink d-inline-flex align-items-center badge-xs">
                      <!-- -->
                      Medium
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- /Projects -->

    <!-- Tasks Statistics -->
    <div class="col-xxl-4 col-xl-5 d-flex">
      <div class="card flex-fill">
        <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
          <h5 class="mb-2">Tasks Statistics</h5>
          <div class="d-flex align-items-center">
            <div class="dropdown mb-2">
              <a
                href="javascript:void(0);"
                class="btn btn-white border btn-sm d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-calendar me-1"></i>This Week
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">This Month</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">This Week</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">Today</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="chartjs-wrapper-demo position-relative mb-4">
            <canvas id="mySemiDonutChart" height="190"></canvas>
            <div class="position-absolute text-center attendance-canvas">
              <p class="fs-13 mb-1">Total Tasks</p>
              <h3>124/165</h3>
            </div>
          </div>
          <div class="d-flex align-items-center flex-wrap">
            <div class="border-end text-center me-2 pe-2 mb-3">
              <p class="fs-13 d-inline-flex align-items-center mb-1">
                <i class="ti ti-circle-filled fs-10 me-1 text-warning"></i>Ongoing
              </p>
              <h5>24%</h5>
            </div>
            <div class="border-end text-center me-2 pe-2 mb-3">
              <p class="fs-13 d-inline-flex align-items-center mb-1">
                <i class="ti ti-circle-filled fs-10 me-1 text-info"></i>On Hold
              </p>
              <h5>10%</h5>
            </div>
            <div class="border-end text-center me-2 pe-2 mb-3">
              <p class="fs-13 d-inline-flex align-items-center mb-1">
                <i class="ti ti-circle-filled fs-10 me-1 text-danger"></i>Overdue
              </p>
              <h5>16%</h5>
            </div>
            <div class="text-center me-2 pe-2 mb-3">
              <p class="fs-13 d-inline-flex align-items-center mb-1">
                <i class="ti ti-circle-filled fs-10 me-1 text-success"></i>Ongoing
              </p>
              <h5>40%</h5>
            </div>
          </div>
          <div class="bg-dark br-5 p-3 pb-0 d-flex align-items-center justify-content-between">
            <div class="mb-2">
              <h4 class="text-success">389/689 hrs</h4>
              <p class="fs-13 mb-0">Spent on Overall Tasks This Week</p>
            </div>
            <a href="tasks.html" class="btn btn-sm btn-light mb-2 text-nowrap">View All</a>
          </div>
        </div>
      </div>
    </div>
    <!-- /Tasks Statistics -->
    <!-- </div> -->

    <!-- <div class="row"> -->
    <!-- Schedules -->
    <div class="col-xxl-4 d-flex">
      <div class="card flex-fill">
        <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
          <h5 class="mb-2">Schedules</h5>
          <a href="candidates.html" class="btn btn-light btn-md mb-2">View All</a>
        </div>
        <div class="card-body">
          <div class="bg-light p-3 br-5 mb-4">
            <span class="badge badge-secondary badge-xs mb-1">UI/ UX Designer</span>
            <h6 class="mb-2 text-truncate">Interview Candidates - UI/UX Designer</h6>
            <div class="d-flex align-items-center flex-wrap">
              <p class="fs-13 mb-1 me-2">
                <i class="ti ti-calendar-event me-2"></i>Thu, 15 Feb 2025
              </p>
              <p class="fs-13 mb-1"><i class="ti ti-clock-hour-11 me-2"></i>01:00 PM - 02:20 PM</p>
            </div>
            <div class="d-flex align-items-center justify-content-between border-top mt-2 pt-3">
              <div class="avatar-list-stacked avatar-group-sm">
                <span class="avatar avatar-rounded">
                  <img class="border border-white" src="assets/img/users/user-49.jpg" alt="img" />
                </span>
                <span class="avatar avatar-rounded">
                  <img class="border border-white" src="assets/img/users/user-13.jpg" alt="img" />
                </span>
                <span class="avatar avatar-rounded">
                  <img class="border border-white" src="assets/img/users/user-11.jpg" alt="img" />
                </span>
                <span class="avatar avatar-rounded">
                  <img class="border border-white" src="assets/img/users/user-22.jpg" alt="img" />
                </span>
                <span class="avatar avatar-rounded">
                  <img class="border border-white" src="assets/img/users/user-58.jpg" alt="img" />
                </span>
                <a
                  class="avatar bg-primary avatar-rounded text-fixed-white fs-10 fw-medium"
                  href="javascript:void(0);"
                >
                  +3
                </a>
              </div>
              <a href="#" class="btn btn-primary btn-xs">Join Meeting</a>
            </div>
          </div>
          <div class="bg-light p-3 br-5 mb-0">
            <span class="badge badge-dark badge-xs mb-1">IOS Developer</span>
            <h6 class="mb-2 text-truncate">Interview Candidates - IOS Developer</h6>
            <div class="d-flex align-items-center flex-wrap">
              <p class="fs-13 mb-1 me-2">
                <i class="ti ti-calendar-event me-2"></i>Thu, 15 Feb 2025
              </p>
              <p class="fs-13 mb-1"><i class="ti ti-clock-hour-11 me-2"></i>02:00 PM - 04:20 PM</p>
            </div>
            <div class="d-flex align-items-center justify-content-between border-top mt-2 pt-3">
              <div class="avatar-list-stacked avatar-group-sm">
                <span class="avatar avatar-rounded">
                  <img class="border border-white" src="assets/img/users/user-49.jpg" alt="img" />
                </span>
                <span class="avatar avatar-rounded">
                  <img class="border border-white" src="assets/img/users/user-13.jpg" alt="img" />
                </span>
                <span class="avatar avatar-rounded">
                  <img class="border border-white" src="assets/img/users/user-11.jpg" alt="img" />
                </span>
                <span class="avatar avatar-rounded">
                  <img class="border border-white" src="assets/img/users/user-22.jpg" alt="img" />
                </span>
                <span class="avatar avatar-rounded">
                  <img class="border border-white" src="assets/img/users/user-58.jpg" alt="img" />
                </span>
                <a
                  class="avatar bg-primary avatar-rounded text-fixed-white fs-10 fw-medium"
                  href="javascript:void(0);"
                >
                  +3
                </a>
              </div>
              <a href="#" class="btn btn-primary btn-xs">Join Meeting</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Schedules -->

    <!-- Recent Activities -->
    <div class="col-xxl-4 col-xl-6 d-flex">
      <div class="card flex-fill">
        <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
          <h5 class="mb-2">Recent Activities</h5>
          <a href="activity.html" class="btn btn-light btn-md mb-2">View All</a>
        </div>
        <div class="card-body">
          <div class="recent-item">
            <div class="d-flex justify-content-between">
              <div class="d-flex align-items-center w-100">
                <a href="javscript:void(0);" class="avatar flex-shrink-0">
                  <img src="assets/img/users/user-38.jpg" class="rounded-circle" alt="img" />
                </a>
                <div class="ms-2 flex-fill">
                  <div class="d-flex align-items-center justify-content-between">
                    <h6 class="fs-medium text-truncate">
                      <a href="javscript:void(0);">Matt Morgan</a>
                    </h6>
                    <p class="fs-13">05:30 PM</p>
                  </div>
                  <p class="fs-13">
                    Added New Project <span class="text-primary">HRMS Dashboard</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="recent-item">
            <div class="d-flex justify-content-between">
              <div class="d-flex align-items-center w-100">
                <a href="javscript:void(0);" class="avatar flex-shrink-0">
                  <img src="assets/img/users/user-01.jpg" class="rounded-circle" alt="img" />
                </a>
                <div class="ms-2 flex-fill">
                  <div class="d-flex align-items-center justify-content-between">
                    <h6 class="fs-medium text-truncate">
                      <a href="javscript:void(0);">Jay Ze</a>
                    </h6>
                    <p class="fs-13">05:00 PM</p>
                  </div>
                  <p class="fs-13">Commented on Uploaded Document</p>
                </div>
              </div>
            </div>
          </div>
          <div class="recent-item">
            <div class="d-flex justify-content-between">
              <div class="d-flex align-items-center w-100">
                <a href="javscript:void(0);" class="avatar flex-shrink-0">
                  <img src="assets/img/users/user-19.jpg" class="rounded-circle" alt="img" />
                </a>
                <div class="ms-2 flex-fill">
                  <div class="d-flex align-items-center justify-content-between">
                    <h6 class="fs-medium text-truncate">
                      <a href="javscript:void(0);">Mary Donald</a>
                    </h6>
                    <p class="fs-13">05:30 PM</p>
                  </div>
                  <p class="fs-13">Approved Task Projects</p>
                </div>
              </div>
            </div>
          </div>
          <div class="recent-item">
            <div class="d-flex justify-content-between">
              <div class="d-flex align-items-center w-100">
                <a href="javscript:void(0);" class="avatar flex-shrink-0">
                  <img src="assets/img/users/user-11.jpg" class="rounded-circle" alt="img" />
                </a>
                <div class="ms-2 flex-fill">
                  <div class="d-flex align-items-center justify-content-between">
                    <h6 class="fs-medium text-truncate">
                      <a href="javscript:void(0);">George David</a>
                    </h6>
                    <p class="fs-13">06:00 PM</p>
                  </div>
                  <p class="fs-13">Requesting Access to Module Tickets</p>
                </div>
              </div>
            </div>
          </div>
          <div class="recent-item">
            <div class="d-flex justify-content-between">
              <div class="d-flex align-items-center w-100">
                <a href="javscript:void(0);" class="avatar flex-shrink-0">
                  <img src="assets/img/users/user-20.jpg" class="rounded-circle" alt="img" />
                </a>
                <div class="ms-2 flex-fill">
                  <div class="d-flex align-items-center justify-content-between">
                    <h6 class="fs-medium text-truncate">
                      <a href="javscript:void(0);">Aaron Zeen</a>
                    </h6>
                    <p class="fs-13">06:30 PM</p>
                  </div>
                  <p class="fs-13">Downloaded App Reportss</p>
                </div>
              </div>
            </div>
          </div>
          <div class="recent-item">
            <div class="d-flex justify-content-between">
              <div class="d-flex align-items-center w-100">
                <a href="javscript:void(0);" class="avatar flex-shrink-0">
                  <img src="assets/img/users/user-08.jpg" class="rounded-circle" alt="img" />
                </a>
                <div class="ms-2 flex-fill">
                  <div class="d-flex align-items-center justify-content-between">
                    <h6 class="fs-medium text-truncate">
                      <a href="javscript:void(0);">Hendry Daniel</a>
                    </h6>
                    <p class="fs-13">05:30 PM</p>
                  </div>
                  <p class="fs-13">Completed New Project <span>HMS</span></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Recent Activities -->

    <!-- Birthdays -->
    <!-- <div class="col-xxl-4 col-xl-6 d-flex "> -->
    <div class="col-xxl-4 col-xl-6 d-flex align-items-start">
      <div class="card flex-fill">
        <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
          <h5 class="mb-2">Birthdays</h5>
          <a
            *ngIf="
              todayBirthdays.length !== 0 ||
              tomorrowBirthdays.length !== 0 ||
              upcomingBirthdays.length !== 0
            "
            [routerLink]="eps.event.birthdaysPath"
            class="btn btn-light btn-md mb-2"
            >View All</a
          >
        </div>
        <ng-container
          *ngIf="
            todayBirthdays.length !== 0 ||
              tomorrowBirthdays.length !== 0 ||
              upcomingBirthdays.length !== 0;
            else noRecords
          "
        >
          <div class="card-body pb-1">
            <h6 class="mb-2">Today</h6>

            <div
              *ngFor="let user of todayBirthdays"
              class="bg-light p-2 border border-dashed rounded-top mb-3"
            >
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <span class="avatar">
                    <!-- If avatar exists, show image -->
                    <img
                      *ngIf="user.picture; else noAvatar"
                      [src]="apiEndpoint + '/uploads/' + user.picture"
                      class="rounded-circle border border-2"
                      alt="img"
                    />

                    <!-- Fallback: first letter of user name -->
                    <ng-template #noAvatar>
                      <span
                        class="avatar avatar-sm online rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white"
                        style="width: 32px; height: 32px"
                      >
                        {{ user.firstName.charAt(0) }}
                      </span>
                    </ng-template>
                  </span>
                  <div class="ms-2 overflow-hidden">
                    <h6 class="fs-medium">{{ user.firstName }} {{ user.lastName }}</h6>
                    <p class="fs-13">
                      {{ user.designation?.designationName || '—' }}
                    </p>
                  </div>
                </div>
                <button class="btn btn-secondary btn-xs">
                  <i class="ti ti-cake me-1"></i>Send
                </button>
              </div>
            </div>
            <h6 *ngIf="tomorrowBirthdays.length !== 0" class="mb-2">Tomorrow</h6>

            <div
              *ngFor="let user of tomorrowBirthdays"
              class="bg-light p-2 border border-dashed rounded-top mb-3"
            >
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <span class="avatar">
                    <img
                      *ngIf="user.picture; else noAvatar"
                      [src]="apiEndpoint + '/uploads/' + user.picture"
                      class="rounded-circle border border-2"
                      alt="img"
                    />

                    <!-- Fallback: first letter of user name -->
                    <ng-template #noAvatar>
                      <span
                        class="avatar avatar-sm online rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white"
                        style="width: 32px; height: 32px"
                      >
                        {{ user.firstName.charAt(0) }}
                      </span>
                    </ng-template>
                  </span>
                  <div class="ms-2 overflow-hidden">
                    <h6 class="fs-medium">{{ user.firstName }} {{ user.lastName }}</h6>
                    <p class="fs-13">{{ user.designation?.designationName || '—' }}</p>
                  </div>
                </div>
                <button class="btn btn-secondary btn-xs">
                  <i class="ti ti-cake me-1"></i>Send
                </button>
              </div>
            </div>

            <h6 *ngIf="upcomingBirthdays.length !== 0" class="mb-2">Upcoming</h6>

            <div
              *ngFor="let user of upcomingBirthdays"
              class="bg-light p-2 border border-dashed rounded-top mb-3"
            >
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <span class="avatar">
                    <img
                      *ngIf="user.picture; else noAvatar"
                      [src]="apiEndpoint + '/uploads/' + user.picture"
                      class="rounded-circle border border-2"
                      alt="img"
                    />

                    <!-- Fallback: first letter of user name -->
                    <ng-template #noAvatar>
                      <span
                        class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                        style="width: 40px; height: 40px"
                      >
                        {{ user.firstName.charAt(0) }}
                      </span>
                    </ng-template>
                  </span>

                  <div class="ms-2 overflow-hidden">
                    <h6 class="fs-medium d-flex align-items-center gap-2">
                      {{ user.firstName }} {{ user.lastName }}

                      <!-- 📅 Date Badge -->
                      <span class="badge bg-soft-primary text-primary fs-10">
                        {{ formatBirthday(user.birthdate) }}
                      </span>
                    </h6>

                    <p class="fs-13">
                      {{ user.designation?.designationName || '—' }}
                    </p>
                  </div>
                </div>

                <button class="btn btn-secondary btn-xs">
                  <i class="ti ti-cake me-1"></i>Send
                </button>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #noRecords>
          <div class="text-center">Record not available</div>
        </ng-template>
      </div>
    </div>
    <!-- </div> -->
    <!-- /Birthdays -->

    <!-- Employees -->
    <div class="col-xxl-12 d-flex">
      <div class="card flex-fill">
        <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
          <h5 class="mb-2">Employees</h5>
          <div class="dropdown mb-2">
            <a
              href="javascript:void(0);"
              class="btn btn-white border btn-sm d-inline-flex align-items-center"
              data-bs-toggle="dropdown"
            >
              <i class="ti ti-calendar me-1"></i>{{ selectedFilterLabel }}
            </a>
            <ul class="dropdown-menu dropdown-menu-end p-3">
              <li>
                <a
                  class="dropdown-item rounded-1"
                  (click)="changeFilter('month', 'employees by department')"
                  >This Month</a
                >
              </li>
              <li>
                <a
                  class="dropdown-item rounded-1"
                  (click)="changeFilter('week', 'employees by department')"
                  >This Week</a
                >
              </li>
              <li>
                <a
                  class="dropdown-item rounded-1"
                  (click)="changeFilter('lastWeek', 'employees by department')"
                  >Last Week</a
                >
              </li>
              <li>
                <a
                  class="dropdown-item rounded-1"
                  (click)="changeFilter('year', 'employees by department')"
                  >This Year</a
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="card-body">
          <div>
            <ng-container *ngIf="chartOptions; else loadingTemplate">
              <apx-chart
                *ngIf="chartOptions"
                [series]="chartOptions.series"
                [chart]="chartOptions.chart"
                [xaxis]="chartOptions.xaxis"
                [yaxis]="chartOptions.yaxis"
                [stroke]="chartOptions.stroke"
                [markers]="chartOptions.markers"
                [dataLabels]="chartOptions.dataLabels"
                [colors]="chartOptions.colors"
              >
              </apx-chart>
            </ng-container>
            <ng-template #loadingTemplate>
              <div class="chart-skeleton">
                <div class="skeleton-rectangle"></div>

                <div class="skeleton-legend d-none">
                  <div class="legend-item" *ngFor="let item of [1, 2, 3]">
                    <div class="legend-color"></div>
                    <div class="legend-text"></div>
                  </div>
                </div>
              </div>
            </ng-template>
          </div>

          <div class="fs-13 mb-2">
            <i class="ti ti-circle-filled me-2 fs-8 text-primary"></i>
            <span>
              Employees {{ thisLabel }} :
              <span class="text-success">{{ thisPeriodCount }}</span>
            </span>

            <div>
              <i class="ti ti-circle-filled me-2 fs-8 text-primary"></i>
              <span>
                Employees {{ lastLabel }} :
                <span class="text-success">{{ lastPeriodCount }}</span>
              </span>
            </div>
          </div>

          <p class="fs-13" *ngIf="increasePercentage !== null">
            <i class="ti ti-circle-filled me-2 fs-8 text-primary"></i>

            Number of Employees <span>{{ trendText }}</span> by

            <span
              class="fw-bold"
              [ngClass]="{
                'text-success': trendText === 'increased',
                'text-danger': trendText === 'decreased',
                'text-muted': trendText === 'not changed'
              }"
            >
              {{ trendText === 'increased' ? '+' : trendText === 'decreased' ? '-' : '' }}
              {{ increasePercentage }}%
            </span>

            from {{ lastLabel }}
          </p>
        </div>
      </div>
    </div>
    <!-- /Employees -->
  </div>
</div>

<!-- <div class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
      <p class="mb-0">2014 - 2025 &copy; SmartHR.</p>
      <p>Designed &amp; Developed By <a href="javascript:void(0);" class="text-primary">Dreams</a></p>
    </div> -->
<!-- </div> -->
<!-- /Page Wrapper -->

<ng-template #loading>
  <app-loader></app-loader>
</ng-template>
